/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.8.0 (NJsonSchema v10.3.11.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

import { ContractTermListDto, Customer, CustomerEditDto, CustomerLocation, CustomerLocationDto, Partner, Product, ProductEditDto, Provider, ProviderEditDto, ProviderListDto, SalesCampaignEntity, User } from './common-proxies';
import { API_BASE_URL, blobToText, throwException } from './proxy-helpers';
import { FileDto, PartnerEditDto, ProductListDto, UserListDto } from './shared-models';

@Injectable()
export class QuoteEmailBodyBuilderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param quoteNumber (optional)
     * @return Success
     */
    withQuoteNumber(quoteNumber: string | undefined): Observable<IQuoteEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/QuoteEmailBodyBuilder/WithQuoteNumber?';
        if (quoteNumber === null) throw new Error("The parameter 'quoteNumber' cannot be null.");
        else if (quoteNumber !== undefined) url_ += 'quoteNumber=' + encodeURIComponent('' + quoteNumber) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithQuoteNumber(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithQuoteNumber(<any>response_);
                        } catch (e) {
                            return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithQuoteNumber(response: HttpResponseBase): Observable<IQuoteEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IQuoteEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IQuoteEmailBodyBuilder>(<any>null);
    }

    /**
     * @param quoteId (optional)
     * @return Success
     */
    withQuoteId(quoteId: string | undefined): Observable<IQuoteEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/QuoteEmailBodyBuilder/WithQuoteId?';
        if (quoteId === null) throw new Error("The parameter 'quoteId' cannot be null.");
        else if (quoteId !== undefined) url_ += 'quoteId=' + encodeURIComponent('' + quoteId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithQuoteId(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithQuoteId(<any>response_);
                        } catch (e) {
                            return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithQuoteId(response: HttpResponseBase): Observable<IQuoteEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IQuoteEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IQuoteEmailBodyBuilder>(<any>null);
    }

    /**
     * @param labelSalesAgent (optional)
     * @return Success
     */
    withLabelSalesAgent(labelSalesAgent: string | undefined): Observable<IQuoteEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/QuoteEmailBodyBuilder/WithLabelSalesAgent?';
        if (labelSalesAgent === null) throw new Error("The parameter 'labelSalesAgent' cannot be null.");
        else if (labelSalesAgent !== undefined) url_ += 'labelSalesAgent=' + encodeURIComponent('' + labelSalesAgent) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithLabelSalesAgent(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithLabelSalesAgent(<any>response_);
                        } catch (e) {
                            return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithLabelSalesAgent(response: HttpResponseBase): Observable<IQuoteEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IQuoteEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IQuoteEmailBodyBuilder>(<any>null);
    }

    /**
     * @param userName (optional)
     * @return Success
     */
    withLoggedInUserName(userName: string | undefined): Observable<IQuoteEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/QuoteEmailBodyBuilder/WithLoggedInUserName?';
        if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined) url_ += 'userName=' + encodeURIComponent('' + userName) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithLoggedInUserName(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithLoggedInUserName(<any>response_);
                        } catch (e) {
                            return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithLoggedInUserName(response: HttpResponseBase): Observable<IQuoteEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IQuoteEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IQuoteEmailBodyBuilder>(<any>null);
    }

    /**
     * @param salesAgent (optional)
     * @return Success
     */
    withSalesAgent(salesAgent: string | undefined): Observable<IQuoteEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/QuoteEmailBodyBuilder/WithSalesAgent?';
        if (salesAgent === null) throw new Error("The parameter 'salesAgent' cannot be null.");
        else if (salesAgent !== undefined) url_ += 'salesAgent=' + encodeURIComponent('' + salesAgent) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithSalesAgent(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithSalesAgent(<any>response_);
                        } catch (e) {
                            return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithSalesAgent(response: HttpResponseBase): Observable<IQuoteEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IQuoteEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IQuoteEmailBodyBuilder>(<any>null);
    }

    /**
     * @param customer (optional)
     * @return Success
     */
    withCustomer(customer: string | undefined): Observable<IQuoteEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/QuoteEmailBodyBuilder/WithCustomer?';
        if (customer === null) throw new Error("The parameter 'customer' cannot be null.");
        else if (customer !== undefined) url_ += 'customer=' + encodeURIComponent('' + customer) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithCustomer(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithCustomer(<any>response_);
                        } catch (e) {
                            return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithCustomer(response: HttpResponseBase): Observable<IQuoteEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IQuoteEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IQuoteEmailBodyBuilder>(<any>null);
    }

    /**
     * @param partner (optional)
     * @return Success
     */
    withPartner(partner: string | undefined): Observable<IQuoteEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/QuoteEmailBodyBuilder/WithPartner?';
        if (partner === null) throw new Error("The parameter 'partner' cannot be null.");
        else if (partner !== undefined) url_ += 'partner=' + encodeURIComponent('' + partner) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithPartner(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithPartner(<any>response_);
                        } catch (e) {
                            return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithPartner(response: HttpResponseBase): Observable<IQuoteEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IQuoteEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IQuoteEmailBodyBuilder>(<any>null);
    }

    /**
     * @param agentEmail (optional)
     * @return Success
     */
    withEmail(agentEmail: string | undefined): Observable<IQuoteEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/QuoteEmailBodyBuilder/WithEmail?';
        if (agentEmail === null) throw new Error("The parameter 'agentEmail' cannot be null.");
        else if (agentEmail !== undefined) url_ += 'agentEmail=' + encodeURIComponent('' + agentEmail) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithEmail(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithEmail(<any>response_);
                        } catch (e) {
                            return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithEmail(response: HttpResponseBase): Observable<IQuoteEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IQuoteEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IQuoteEmailBodyBuilder>(<any>null);
    }

    /**
     * @param agentPhoneNumber (optional)
     * @return Success
     */
    withAgentPhoneNumber(agentPhoneNumber: string | undefined): Observable<IQuoteEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/QuoteEmailBodyBuilder/WithAgentPhoneNumber?';
        if (agentPhoneNumber === null) throw new Error("The parameter 'agentPhoneNumber' cannot be null.");
        else if (agentPhoneNumber !== undefined) url_ += 'agentPhoneNumber=' + encodeURIComponent('' + agentPhoneNumber) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithAgentPhoneNumber(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithAgentPhoneNumber(<any>response_);
                        } catch (e) {
                            return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithAgentPhoneNumber(response: HttpResponseBase): Observable<IQuoteEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IQuoteEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IQuoteEmailBodyBuilder>(<any>null);
    }

    /**
     * @param priceRequestNotes (optional)
     * @return Success
     */
    withPriceRequestNotes(priceRequestNotes: string | undefined): Observable<IQuoteEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/QuoteEmailBodyBuilder/WithPriceRequestNotes?';
        if (priceRequestNotes === null) throw new Error("The parameter 'priceRequestNotes' cannot be null.");
        else if (priceRequestNotes !== undefined) url_ += 'priceRequestNotes=' + encodeURIComponent('' + priceRequestNotes) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithPriceRequestNotes(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithPriceRequestNotes(<any>response_);
                        } catch (e) {
                            return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithPriceRequestNotes(response: HttpResponseBase): Observable<IQuoteEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IQuoteEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IQuoteEmailBodyBuilder>(<any>null);
    }

    /**
     * @param requestPaperworkUrl (optional)
     * @return Success
     */
    withRequestPaperworkUrl(requestPaperworkUrl: string | undefined): Observable<IQuoteEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/QuoteEmailBodyBuilder/WithRequestPaperworkUrl?';
        if (requestPaperworkUrl === null) throw new Error("The parameter 'requestPaperworkUrl' cannot be null.");
        else if (requestPaperworkUrl !== undefined) url_ += 'requestPaperworkUrl=' + encodeURIComponent('' + requestPaperworkUrl) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithRequestPaperworkUrl(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithRequestPaperworkUrl(<any>response_);
                        } catch (e) {
                            return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithRequestPaperworkUrl(response: HttpResponseBase): Observable<IQuoteEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IQuoteEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IQuoteEmailBodyBuilder>(<any>null);
    }

    /**
     * @param quoteUrl (optional)
     * @return Success
     */
    withViewQuoteUrl(quoteUrl: string | undefined): Observable<IQuoteEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/QuoteEmailBodyBuilder/WithViewQuoteUrl?';
        if (quoteUrl === null) throw new Error("The parameter 'quoteUrl' cannot be null.");
        else if (quoteUrl !== undefined) url_ += 'quoteUrl=' + encodeURIComponent('' + quoteUrl) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithViewQuoteUrl(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithViewQuoteUrl(<any>response_);
                        } catch (e) {
                            return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithViewQuoteUrl(response: HttpResponseBase): Observable<IQuoteEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IQuoteEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IQuoteEmailBodyBuilder>(<any>null);
    }

    /**
     * @param providerSpotlightTemplate (optional)
     * @return Success
     */
    withProviderSpotlightTemplate(providerSpotlightTemplate: string | undefined): Observable<IQuoteEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/QuoteEmailBodyBuilder/WithProviderSpotlightTemplate?';
        if (providerSpotlightTemplate === null) throw new Error("The parameter 'providerSpotlightTemplate' cannot be null.");
        else if (providerSpotlightTemplate !== undefined)
            url_ += 'providerSpotlightTemplate=' + encodeURIComponent('' + providerSpotlightTemplate) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithProviderSpotlightTemplate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithProviderSpotlightTemplate(<any>response_);
                        } catch (e) {
                            return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithProviderSpotlightTemplate(response: HttpResponseBase): Observable<IQuoteEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IQuoteEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IQuoteEmailBodyBuilder>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    withQuoteProviderTemplate(body: any | undefined): Observable<IQuoteEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/QuoteEmailBodyBuilder/WithQuoteProviderTemplate';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithQuoteProviderTemplate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithQuoteProviderTemplate(<any>response_);
                        } catch (e) {
                            return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithQuoteProviderTemplate(response: HttpResponseBase): Observable<IQuoteEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IQuoteEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IQuoteEmailBodyBuilder>(<any>null);
    }

    /**
     * @param labelMRR (optional)
     * @return Success
     */
    withLabelMRR(labelMRR: string | undefined): Observable<IQuoteEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/QuoteEmailBodyBuilder/WithLabelMRR?';
        if (labelMRR === null) throw new Error("The parameter 'labelMRR' cannot be null.");
        else if (labelMRR !== undefined) url_ += 'labelMRR=' + encodeURIComponent('' + labelMRR) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithLabelMRR(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithLabelMRR(<any>response_);
                        } catch (e) {
                            return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithLabelMRR(response: HttpResponseBase): Observable<IQuoteEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IQuoteEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IQuoteEmailBodyBuilder>(<any>null);
    }

    /**
     * @param imageUrl (optional)
     * @param providerName (optional)
     * @return Success
     */
    withQuoteProviderLogoTemplate(imageUrl: string | undefined, providerName: string | undefined): Observable<IQuoteEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/QuoteEmailBodyBuilder/WithQuoteProviderLogoTemplate?';
        if (imageUrl === null) throw new Error("The parameter 'imageUrl' cannot be null.");
        else if (imageUrl !== undefined) url_ += 'imageUrl=' + encodeURIComponent('' + imageUrl) + '&';
        if (providerName === null) throw new Error("The parameter 'providerName' cannot be null.");
        else if (providerName !== undefined) url_ += 'providerName=' + encodeURIComponent('' + providerName) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithQuoteProviderLogoTemplate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithQuoteProviderLogoTemplate(<any>response_);
                        } catch (e) {
                            return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithQuoteProviderLogoTemplate(response: HttpResponseBase): Observable<IQuoteEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IQuoteEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IQuoteEmailBodyBuilder>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    withProductSection(body: ProductListForQuote[] | undefined): Observable<IQuoteEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/QuoteEmailBodyBuilder/WithProductSection';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithProductSection(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithProductSection(<any>response_);
                        } catch (e) {
                            return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithProductSection(response: HttpResponseBase): Observable<IQuoteEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IQuoteEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IQuoteEmailBodyBuilder>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    withProvidersProductSection(body: ProviderListForQuote[] | undefined): Observable<IQuoteEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/QuoteEmailBodyBuilder/WithProvidersProductSection';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithProvidersProductSection(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithProvidersProductSection(<any>response_);
                        } catch (e) {
                            return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithProvidersProductSection(response: HttpResponseBase): Observable<IQuoteEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IQuoteEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IQuoteEmailBodyBuilder>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    withBaseTemplate(body: any | undefined): Observable<IQuoteEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/QuoteEmailBodyBuilder/WithBaseTemplate';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithBaseTemplate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithBaseTemplate(<any>response_);
                        } catch (e) {
                            return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithBaseTemplate(response: HttpResponseBase): Observable<IQuoteEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IQuoteEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IQuoteEmailBodyBuilder>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    withBodyTemplate(body: any | undefined): Observable<IQuoteEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/QuoteEmailBodyBuilder/WithBodyTemplate';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithBodyTemplate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithBodyTemplate(<any>response_);
                        } catch (e) {
                            return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithBodyTemplate(response: HttpResponseBase): Observable<IQuoteEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IQuoteEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IQuoteEmailBodyBuilder>(<any>null);
    }

    /**
     * @param headerText (optional)
     * @return Success
     */
    withHeader(headerText: string | undefined): Observable<IQuoteEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/QuoteEmailBodyBuilder/WithHeader?';
        if (headerText === null) throw new Error("The parameter 'headerText' cannot be null.");
        else if (headerText !== undefined) url_ += 'headerText=' + encodeURIComponent('' + headerText) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithHeader(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithHeader(<any>response_);
                        } catch (e) {
                            return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithHeader(response: HttpResponseBase): Observable<IQuoteEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IQuoteEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IQuoteEmailBodyBuilder>(<any>null);
    }

    /**
     * @param shouldThrow (optional)
     * @return Success
     */
    build(shouldThrow: boolean | undefined): Observable<any> {
        let url_ = this.baseUrl + '/api/services/app/QuoteEmailBodyBuilder/Build?';
        if (shouldThrow === null) throw new Error("The parameter 'shouldThrow' cannot be null.");
        else if (shouldThrow !== undefined) url_ += 'shouldThrow=' + encodeURIComponent('' + shouldThrow) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processBuild(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processBuild(<any>response_);
                        } catch (e) {
                            return <Observable<any>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<any>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processBuild(response: HttpResponseBase): Observable<any> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<any>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    validateBodyTemplatePlaceholders(body: any | undefined): Observable<string[]> {
        let url_ = this.baseUrl + '/api/services/app/QuoteEmailBodyBuilder/ValidateBodyTemplatePlaceholders';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processValidateBodyTemplatePlaceholders(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processValidateBodyTemplatePlaceholders(<any>response_);
                        } catch (e) {
                            return <Observable<string[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<string[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processValidateBodyTemplatePlaceholders(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(item);
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<string[]>([]);
    }

    /**
     * @param title (optional)
     * @param email (optional)
     * @param phoneNumber (optional)
     * @return Success
     */
    withAssignedUserInfo(
        title: string | undefined,
        email: string | undefined,
        phoneNumber: string | undefined
    ): Observable<IQuoteEmailBodyBuilder> {
        let url_ = this.baseUrl + '/api/services/app/QuoteEmailBodyBuilder/WithAssignedUserInfo?';
        if (title === null) throw new Error("The parameter 'title' cannot be null.");
        else if (title !== undefined) url_ += 'title=' + encodeURIComponent('' + title) + '&';
        if (email === null) throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined) url_ += 'email=' + encodeURIComponent('' + email) + '&';
        if (phoneNumber === null) throw new Error("The parameter 'phoneNumber' cannot be null.");
        else if (phoneNumber !== undefined) url_ += 'phoneNumber=' + encodeURIComponent('' + phoneNumber) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processWithAssignedUserInfo(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processWithAssignedUserInfo(<any>response_);
                        } catch (e) {
                            return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<IQuoteEmailBodyBuilder>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processWithAssignedUserInfo(response: HttpResponseBase): Observable<IQuoteEmailBodyBuilder> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = IQuoteEmailBodyBuilder.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<IQuoteEmailBodyBuilder>(<any>null);
    }
}

@Injectable()
export class QuotesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @param quoteStageTypeIds (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @param quoteNumber (optional)
     * @param address (optional)
     * @param city (optional)
     * @param state (optional)
     * @param zipcode (optional)
     * @param partnerId (optional)
     * @param customerId (optional)
     * @param customerLocationId (optional)
     * @param providerId (optional)
     * @param spmIdList (optional)
     * @param investOwnerIdList (optional)
     * @param supportId (optional)
     * @param salesAgentIdsAsString (optional)
     * @param advisorEntitlementId (optional)
     * @param salesCampaignsIdList (optional)
     * @param internalSalesAgentsIdList (optional)
     * @param accountManagersIdList (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getQuotesForTable(
        quoteStageTypeIds: string | undefined,
        startDate: moment.Moment | undefined,
        endDate: moment.Moment | undefined,
        quoteNumber: string | undefined,
        address: string | undefined,
        city: string | undefined,
        state: string | undefined,
        zipcode: string | undefined,
        partnerId: string | undefined,
        customerId: string | undefined,
        customerLocationId: number | undefined,
        providerId: string | undefined,
        spmIdList: string | undefined,
        investOwnerIdList: string | undefined,
        supportId: string | undefined,
        salesAgentIdsAsString: string | undefined,
        advisorEntitlementId: number | undefined,
        salesCampaignsIdList: string | undefined,
        internalSalesAgentsIdList: string | undefined,
        accountManagersIdList: string | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<QuoteListOutputPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetQuotesForTable?';
        if (quoteStageTypeIds === null) throw new Error("The parameter 'quoteStageTypeIds' cannot be null.");
        else if (quoteStageTypeIds !== undefined) url_ += 'QuoteStageTypeIds=' + encodeURIComponent('' + quoteStageTypeIds) + '&';
        if (startDate === null) throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined) url_ += 'StartDate=' + encodeURIComponent(startDate ? '' + startDate.toJSON() : '') + '&';
        if (endDate === null) throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined) url_ += 'EndDate=' + encodeURIComponent(endDate ? '' + endDate.toJSON() : '') + '&';
        if (quoteNumber === null) throw new Error("The parameter 'quoteNumber' cannot be null.");
        else if (quoteNumber !== undefined) url_ += 'QuoteNumber=' + encodeURIComponent('' + quoteNumber) + '&';
        if (address === null) throw new Error("The parameter 'address' cannot be null.");
        else if (address !== undefined) url_ += 'Address=' + encodeURIComponent('' + address) + '&';
        if (city === null) throw new Error("The parameter 'city' cannot be null.");
        else if (city !== undefined) url_ += 'City=' + encodeURIComponent('' + city) + '&';
        if (state === null) throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined) url_ += 'State=' + encodeURIComponent('' + state) + '&';
        if (zipcode === null) throw new Error("The parameter 'zipcode' cannot be null.");
        else if (zipcode !== undefined) url_ += 'Zipcode=' + encodeURIComponent('' + zipcode) + '&';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'PartnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (customerId === null) throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined) url_ += 'CustomerId=' + encodeURIComponent('' + customerId) + '&';
        if (customerLocationId === null) throw new Error("The parameter 'customerLocationId' cannot be null.");
        else if (customerLocationId !== undefined) url_ += 'CustomerLocationId=' + encodeURIComponent('' + customerLocationId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        if (spmIdList === null) throw new Error("The parameter 'spmIdList' cannot be null.");
        else if (spmIdList !== undefined) url_ += 'SpmIdList=' + encodeURIComponent('' + spmIdList) + '&';
        if (investOwnerIdList === null) throw new Error("The parameter 'investOwnerIdList' cannot be null.");
        else if (investOwnerIdList !== undefined) url_ += 'InvestOwnerIdList=' + encodeURIComponent('' + investOwnerIdList) + '&';
        if (supportId === null) throw new Error("The parameter 'supportId' cannot be null.");
        else if (supportId !== undefined) url_ += 'SupportId=' + encodeURIComponent('' + supportId) + '&';
        if (salesAgentIdsAsString === null) throw new Error("The parameter 'salesAgentIdsAsString' cannot be null.");
        else if (salesAgentIdsAsString !== undefined)
            url_ += 'SalesAgentIdsAsString=' + encodeURIComponent('' + salesAgentIdsAsString) + '&';
        if (advisorEntitlementId === null) throw new Error("The parameter 'advisorEntitlementId' cannot be null.");
        else if (advisorEntitlementId !== undefined) url_ += 'AdvisorEntitlementId=' + encodeURIComponent('' + advisorEntitlementId) + '&';
        if (salesCampaignsIdList === null) throw new Error("The parameter 'salesCampaignsIdList' cannot be null.");
        else if (salesCampaignsIdList !== undefined) url_ += 'SalesCampaignsIdList=' + encodeURIComponent('' + salesCampaignsIdList) + '&';
        if (internalSalesAgentsIdList === null) throw new Error("The parameter 'internalSalesAgentsIdList' cannot be null.");
        else if (internalSalesAgentsIdList !== undefined)
            url_ += 'InternalSalesAgentsIdList=' + encodeURIComponent('' + internalSalesAgentsIdList) + '&';
        if (accountManagersIdList === null) throw new Error("The parameter 'accountManagersIdList' cannot be null.");
        else if (accountManagersIdList !== undefined)
            url_ += 'AccountManagersIdList=' + encodeURIComponent('' + accountManagersIdList) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetQuotesForTable(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetQuotesForTable(<any>response_);
                        } catch (e) {
                            return <Observable<QuoteListOutputPagedResultDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<QuoteListOutputPagedResultDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetQuotesForTable(response: HttpResponseBase): Observable<QuoteListOutputPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = QuoteListOutputPagedResultDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<QuoteListOutputPagedResultDto>(<any>null);
    }

    /**
     * @param providerInput (optional)
     * @param quoteStageType (optional)
     * @param startMonth (optional)
     * @param startYear (optional)
     * @param endMonth (optional)
     * @param endYear (optional)
     * @param productCategoryInput (optional)
     * @param productInput (optional)
     * @return Success
     */
    getReportExecSummProviderQuotes(
        providerInput: string | undefined,
        quoteStageType: string | undefined,
        startMonth: number | undefined,
        startYear: number | undefined,
        endMonth: number | undefined,
        endYear: number | undefined,
        productCategoryInput: string | undefined,
        productInput: string | undefined
    ): Observable<OutputReportExecSummProviderQuotes[]> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetReportExecSummProviderQuotes?';
        if (providerInput === null) throw new Error("The parameter 'providerInput' cannot be null.");
        else if (providerInput !== undefined) url_ += 'providerInput=' + encodeURIComponent('' + providerInput) + '&';
        if (quoteStageType === null) throw new Error("The parameter 'quoteStageType' cannot be null.");
        else if (quoteStageType !== undefined) url_ += 'quoteStageType=' + encodeURIComponent('' + quoteStageType) + '&';
        if (startMonth === null) throw new Error("The parameter 'startMonth' cannot be null.");
        else if (startMonth !== undefined) url_ += 'startMonth=' + encodeURIComponent('' + startMonth) + '&';
        if (startYear === null) throw new Error("The parameter 'startYear' cannot be null.");
        else if (startYear !== undefined) url_ += 'startYear=' + encodeURIComponent('' + startYear) + '&';
        if (endMonth === null) throw new Error("The parameter 'endMonth' cannot be null.");
        else if (endMonth !== undefined) url_ += 'endMonth=' + encodeURIComponent('' + endMonth) + '&';
        if (endYear === null) throw new Error("The parameter 'endYear' cannot be null.");
        else if (endYear !== undefined) url_ += 'endYear=' + encodeURIComponent('' + endYear) + '&';
        if (productCategoryInput === null) throw new Error("The parameter 'productCategoryInput' cannot be null.");
        else if (productCategoryInput !== undefined) url_ += 'productCategoryInput=' + encodeURIComponent('' + productCategoryInput) + '&';
        if (productInput === null) throw new Error("The parameter 'productInput' cannot be null.");
        else if (productInput !== undefined) url_ += 'productInput=' + encodeURIComponent('' + productInput) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetReportExecSummProviderQuotes(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetReportExecSummProviderQuotes(<any>response_);
                        } catch (e) {
                            return <Observable<OutputReportExecSummProviderQuotes[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OutputReportExecSummProviderQuotes[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetReportExecSummProviderQuotes(response: HttpResponseBase): Observable<OutputReportExecSummProviderQuotes[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OutputReportExecSummProviderQuotes.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OutputReportExecSummProviderQuotes[]>([]);
    }

    /**
     * @param partnerInput (optional)
     * @param quoteStageType (optional)
     * @param startMonth (optional)
     * @param startYear (optional)
     * @param endMonth (optional)
     * @param endYear (optional)
     * @param productCategoryInput (optional)
     * @param productInput (optional)
     * @return Success
     */
    getReportExecSummPartnerQuotes(
        partnerInput: string | undefined,
        quoteStageType: string | undefined,
        startMonth: number | undefined,
        startYear: number | undefined,
        endMonth: number | undefined,
        endYear: number | undefined,
        productCategoryInput: string | undefined,
        productInput: string | undefined
    ): Observable<OutputReportExecSummPartnerQuotes[]> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetReportExecSummPartnerQuotes?';
        if (partnerInput === null) throw new Error("The parameter 'partnerInput' cannot be null.");
        else if (partnerInput !== undefined) url_ += 'partnerInput=' + encodeURIComponent('' + partnerInput) + '&';
        if (quoteStageType === null) throw new Error("The parameter 'quoteStageType' cannot be null.");
        else if (quoteStageType !== undefined) url_ += 'quoteStageType=' + encodeURIComponent('' + quoteStageType) + '&';
        if (startMonth === null) throw new Error("The parameter 'startMonth' cannot be null.");
        else if (startMonth !== undefined) url_ += 'startMonth=' + encodeURIComponent('' + startMonth) + '&';
        if (startYear === null) throw new Error("The parameter 'startYear' cannot be null.");
        else if (startYear !== undefined) url_ += 'startYear=' + encodeURIComponent('' + startYear) + '&';
        if (endMonth === null) throw new Error("The parameter 'endMonth' cannot be null.");
        else if (endMonth !== undefined) url_ += 'endMonth=' + encodeURIComponent('' + endMonth) + '&';
        if (endYear === null) throw new Error("The parameter 'endYear' cannot be null.");
        else if (endYear !== undefined) url_ += 'endYear=' + encodeURIComponent('' + endYear) + '&';
        if (productCategoryInput === null) throw new Error("The parameter 'productCategoryInput' cannot be null.");
        else if (productCategoryInput !== undefined) url_ += 'productCategoryInput=' + encodeURIComponent('' + productCategoryInput) + '&';
        if (productInput === null) throw new Error("The parameter 'productInput' cannot be null.");
        else if (productInput !== undefined) url_ += 'productInput=' + encodeURIComponent('' + productInput) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetReportExecSummPartnerQuotes(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetReportExecSummPartnerQuotes(<any>response_);
                        } catch (e) {
                            return <Observable<OutputReportExecSummPartnerQuotes[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OutputReportExecSummPartnerQuotes[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetReportExecSummPartnerQuotes(response: HttpResponseBase): Observable<OutputReportExecSummPartnerQuotes[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OutputReportExecSummPartnerQuotes.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OutputReportExecSummPartnerQuotes[]>([]);
    }

    /**
     * @return Success
     */
    getActiveQuotesCountAging(): Observable<ActiveQuoteCountAging> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetActiveQuotesCountAging';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetActiveQuotesCountAging(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetActiveQuotesCountAging(<any>response_);
                        } catch (e) {
                            return <Observable<ActiveQuoteCountAging>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<ActiveQuoteCountAging>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetActiveQuotesCountAging(response: HttpResponseBase): Observable<ActiveQuoteCountAging> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ActiveQuoteCountAging.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ActiveQuoteCountAging>(<any>null);
    }

    /**
     * @return Success
     */
    getQuoteUsersList(): Observable<QuoteUserListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetQuoteUsersList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetQuoteUsersList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetQuoteUsersList(<any>response_);
                        } catch (e) {
                            return <Observable<QuoteUserListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<QuoteUserListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetQuoteUsersList(response: HttpResponseBase): Observable<QuoteUserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(QuoteUserListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<QuoteUserListDto[]>([]);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getUsersList(id: number | undefined): Observable<UserListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetUsersList?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetUsersList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetUsersList(<any>response_);
                        } catch (e) {
                            return <Observable<UserListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<UserListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetUsersList(response: HttpResponseBase): Observable<UserListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(UserListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<UserListDto[]>([]);
    }

    /**
     * @param quoteId (optional)
     * @return Success
     */
    getQuoteForEdit(quoteId: number | undefined): Observable<QuoteManageDto> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetQuoteForEdit?';
        if (quoteId === null) throw new Error("The parameter 'quoteId' cannot be null.");
        else if (quoteId !== undefined) url_ += 'quoteId=' + encodeURIComponent('' + quoteId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetQuoteForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetQuoteForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<QuoteManageDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<QuoteManageDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetQuoteForEdit(response: HttpResponseBase): Observable<QuoteManageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = QuoteManageDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<QuoteManageDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateQuoteDetailPricing(body: QuoteManageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/UpdateQuoteDetailPricing';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateQuoteDetailPricing(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateQuoteDetailPricing(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateQuoteDetailPricing(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param quoteId (optional)
     * @param internalSalesAgentId (optional)
     * @return Success
     */
    updateQuoteInternalSalesAgent(quoteId: number | undefined, internalSalesAgentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/UpdateQuoteInternalSalesAgent?';
        if (quoteId === null) throw new Error("The parameter 'quoteId' cannot be null.");
        else if (quoteId !== undefined) url_ += 'quoteId=' + encodeURIComponent('' + quoteId) + '&';
        if (internalSalesAgentId === null) throw new Error("The parameter 'internalSalesAgentId' cannot be null.");
        else if (internalSalesAgentId !== undefined) url_ += 'internalSalesAgentId=' + encodeURIComponent('' + internalSalesAgentId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateQuoteInternalSalesAgent(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateQuoteInternalSalesAgent(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateQuoteInternalSalesAgent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getQuotePriceDetailForEdit(id: number | undefined): Observable<QuotePriceDetailEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetQuotePriceDetailForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetQuotePriceDetailForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetQuotePriceDetailForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<QuotePriceDetailEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<QuotePriceDetailEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetQuotePriceDetailForEdit(response: HttpResponseBase): Observable<QuotePriceDetailEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = QuotePriceDetailEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<QuotePriceDetailEditDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getQuotePriceDetailContractForEdit(id: number | undefined): Observable<QuotePriceDetailContractEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetQuotePriceDetailContractForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetQuotePriceDetailContractForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetQuotePriceDetailContractForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<QuotePriceDetailContractEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<QuotePriceDetailContractEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetQuotePriceDetailContractForEdit(response: HttpResponseBase): Observable<QuotePriceDetailContractEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = QuotePriceDetailContractEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<QuotePriceDetailContractEditDto>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateQuote(body: CreateOrUpdateQuoteInput | undefined): Observable<number> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/CreateOrUpdateQuote';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateOrUpdateQuote(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateOrUpdateQuote(<any>response_);
                        } catch (e) {
                            return <Observable<number>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<number>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateOrUpdateQuote(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = resultData200 !== undefined ? resultData200 : <any>null;
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getQuoteLocationForEdit(id: number | undefined): Observable<QuoteLocationEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetQuoteLocationForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetQuoteLocationForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetQuoteLocationForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<QuoteLocationEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<QuoteLocationEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetQuoteLocationForEdit(response: HttpResponseBase): Observable<QuoteLocationEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = QuoteLocationEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<QuoteLocationEditDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getQuoteContractTermForEdit(id: number | undefined): Observable<QuoteContractTermEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetQuoteContractTermForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetQuoteContractTermForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetQuoteContractTermForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<QuoteContractTermEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<QuoteContractTermEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetQuoteContractTermForEdit(response: HttpResponseBase): Observable<QuoteContractTermEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = QuoteContractTermEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<QuoteContractTermEditDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getQuoteProductForEdit(id: number | undefined): Observable<QuoteProductEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetQuoteProductForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetQuoteProductForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetQuoteProductForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<QuoteProductEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<QuoteProductEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetQuoteProductForEdit(response: HttpResponseBase): Observable<QuoteProductEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = QuoteProductEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<QuoteProductEditDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getQuoteProviderForEdit(id: number | undefined): Observable<QuoteProviderEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetQuoteProviderForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetQuoteProviderForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetQuoteProviderForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<QuoteProviderEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<QuoteProviderEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetQuoteProviderForEdit(response: HttpResponseBase): Observable<QuoteProviderEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = QuoteProviderEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<QuoteProviderEditDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getQuoteProviderProductForEdit(id: number | undefined): Observable<QuoteProviderProductEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetQuoteProviderProductForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetQuoteProviderProductForEdit(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetQuoteProviderProductForEdit(<any>response_);
                        } catch (e) {
                            return <Observable<QuoteProviderProductEditDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<QuoteProviderProductEditDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetQuoteProviderProductForEdit(response: HttpResponseBase): Observable<QuoteProviderProductEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = QuoteProviderProductEditDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<QuoteProviderProductEditDto>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteQuote(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/DeleteQuote?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({}),
        };

        return this.http
            .request('delete', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processDeleteQuote(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processDeleteQuote(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processDeleteQuote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createQuoteUser(body: CreateOrUpdateQuoteUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/CreateQuoteUserAsync';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processCreateQuoteUser(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processCreateQuoteUser(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processCreateQuoteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getQuoteStatusList(): Observable<QuoteStatusDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetQuoteStatusList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetQuoteStatusList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetQuoteStatusList(<any>response_);
                        } catch (e) {
                            return <Observable<QuoteStatusDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<QuoteStatusDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetQuoteStatusList(response: HttpResponseBase): Observable<QuoteStatusDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(QuoteStatusDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<QuoteStatusDto[]>([]);
    }

    /**
     * @return Success
     */
    getQuoteStageTypeList(): Observable<QuoteStageTypeDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetQuoteStageTypeList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetQuoteStageTypeList(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetQuoteStageTypeList(<any>response_);
                        } catch (e) {
                            return <Observable<QuoteStageTypeDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<QuoteStageTypeDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetQuoteStageTypeList(response: HttpResponseBase): Observable<QuoteStageTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(QuoteStageTypeDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<QuoteStageTypeDto[]>([]);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendRequestOnReview(body: UpdateQuoteReviewInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/SendRequestOnReview';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processSendRequestOnReview(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processSendRequestOnReview(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processSendRequestOnReview(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    requestPricingOnReview(body: UpdateQuoteReviewInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/RequestPricingOnReview';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('post', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processRequestPricingOnReview(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processRequestPricingOnReview(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processRequestPricingOnReview(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateQuoteStage(body: UpdateQuoteStageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/UpdateQuoteStage';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
            }),
        };

        return this.http
            .request('put', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processUpdateQuoteStage(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processUpdateQuoteStage(<any>response_);
                        } catch (e) {
                            return <Observable<void>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<void>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processUpdateQuoteStage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return _observableOf<void>(<any>null);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getQuoteEstMrc(id: number | undefined): Observable<QuoteManageEstMrcListDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetQuoteEstMrc?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetQuoteEstMrc(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetQuoteEstMrc(<any>response_);
                        } catch (e) {
                            return <Observable<QuoteManageEstMrcListDto[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<QuoteManageEstMrcListDto[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetQuoteEstMrc(response: HttpResponseBase): Observable<QuoteManageEstMrcListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(QuoteManageEstMrcListDto.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<QuoteManageEstMrcListDto[]>([]);
    }

    /**
     * @param partnerId (optional)
     * @return Success
     */
    getQuotesCountByStageDashboard(partnerId: number | undefined): Observable<QuotesCountByStageDashboardOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetQuotesCountByStageDashboard?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetQuotesCountByStageDashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetQuotesCountByStageDashboard(<any>response_);
                        } catch (e) {
                            return <Observable<QuotesCountByStageDashboardOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<QuotesCountByStageDashboardOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetQuotesCountByStageDashboard(response: HttpResponseBase): Observable<QuotesCountByStageDashboardOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(QuotesCountByStageDashboardOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<QuotesCountByStageDashboardOutput[]>([]);
    }

    /**
     * @param userId (optional)
     * @return Success
     */
    getOpenQuotesAgingDashboard(userId: number | undefined): Observable<OpenQuotesAgingDashboardOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetOpenQuotesAgingDashboard?';
        if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined) url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOpenQuotesAgingDashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOpenQuotesAgingDashboard(<any>response_);
                        } catch (e) {
                            return <Observable<OpenQuotesAgingDashboardOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OpenQuotesAgingDashboardOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOpenQuotesAgingDashboard(response: HttpResponseBase): Observable<OpenQuotesAgingDashboardOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OpenQuotesAgingDashboardOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OpenQuotesAgingDashboardOutput[]>([]);
    }

    /**
     * @param userId (optional)
     * @return Success
     */
    getOpenQuotesAgingForAssignedUserDashboard(userId: number | undefined): Observable<OpenQuotesAgingDashboardOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetOpenQuotesAgingForAssignedUserDashboard?';
        if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined) url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOpenQuotesAgingForAssignedUserDashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOpenQuotesAgingForAssignedUserDashboard(<any>response_);
                        } catch (e) {
                            return <Observable<OpenQuotesAgingDashboardOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OpenQuotesAgingDashboardOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOpenQuotesAgingForAssignedUserDashboard(response: HttpResponseBase): Observable<OpenQuotesAgingDashboardOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OpenQuotesAgingDashboardOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OpenQuotesAgingDashboardOutput[]>([]);
    }

    /**
     * @param supportId (optional)
     * @return Success
     * @deprecated
     */
    getOpenQuotesAgingByAssignedUserDashboard(supportId: number | undefined): Observable<OpenQuotesAgingDashboardOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetOpenQuotesAgingByAssignedUserDashboard?';
        if (supportId === null) throw new Error("The parameter 'supportId' cannot be null.");
        else if (supportId !== undefined) url_ += 'supportId=' + encodeURIComponent('' + supportId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetOpenQuotesAgingByAssignedUserDashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetOpenQuotesAgingByAssignedUserDashboard(<any>response_);
                        } catch (e) {
                            return <Observable<OpenQuotesAgingDashboardOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<OpenQuotesAgingDashboardOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetOpenQuotesAgingByAssignedUserDashboard(response: HttpResponseBase): Observable<OpenQuotesAgingDashboardOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(OpenQuotesAgingDashboardOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<OpenQuotesAgingDashboardOutput[]>([]);
    }

    /**
     * @param startMonth (optional)
     * @param startYear (optional)
     * @param endMonth (optional)
     * @param endYear (optional)
     * @return Success
     */
    getReportDetailsQuotesToExcel(
        startMonth: number | undefined,
        startYear: number | undefined,
        endMonth: number | undefined,
        endYear: number | undefined
    ): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetReportDetailsQuotesToExcel?';
        if (startMonth === null) throw new Error("The parameter 'startMonth' cannot be null.");
        else if (startMonth !== undefined) url_ += 'startMonth=' + encodeURIComponent('' + startMonth) + '&';
        if (startYear === null) throw new Error("The parameter 'startYear' cannot be null.");
        else if (startYear !== undefined) url_ += 'startYear=' + encodeURIComponent('' + startYear) + '&';
        if (endMonth === null) throw new Error("The parameter 'endMonth' cannot be null.");
        else if (endMonth !== undefined) url_ += 'endMonth=' + encodeURIComponent('' + endMonth) + '&';
        if (endYear === null) throw new Error("The parameter 'endYear' cannot be null.");
        else if (endYear !== undefined) url_ += 'endYear=' + encodeURIComponent('' + endYear) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetReportDetailsQuotesToExcel(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetReportDetailsQuotesToExcel(<any>response_);
                        } catch (e) {
                            return <Observable<FileDto>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<FileDto>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetReportDetailsQuotesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = FileDto.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<FileDto>(<any>null);
    }

    /**
     * @param startMonth (optional)
     * @param startYear (optional)
     * @param endMonth (optional)
     * @param endYear (optional)
     * @param searchType (optional)
     * @return Success
     */
    getReportTrendingQuotes(
        startMonth: number | undefined,
        startYear: number | undefined,
        endMonth: number | undefined,
        endYear: number | undefined,
        searchType: string | undefined
    ): Observable<QuoteTrendingReportOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetReportTrendingQuotes?';
        if (startMonth === null) throw new Error("The parameter 'startMonth' cannot be null.");
        else if (startMonth !== undefined) url_ += 'startMonth=' + encodeURIComponent('' + startMonth) + '&';
        if (startYear === null) throw new Error("The parameter 'startYear' cannot be null.");
        else if (startYear !== undefined) url_ += 'startYear=' + encodeURIComponent('' + startYear) + '&';
        if (endMonth === null) throw new Error("The parameter 'endMonth' cannot be null.");
        else if (endMonth !== undefined) url_ += 'endMonth=' + encodeURIComponent('' + endMonth) + '&';
        if (endYear === null) throw new Error("The parameter 'endYear' cannot be null.");
        else if (endYear !== undefined) url_ += 'endYear=' + encodeURIComponent('' + endYear) + '&';
        if (searchType === null) throw new Error("The parameter 'searchType' cannot be null.");
        else if (searchType !== undefined) url_ += 'searchType=' + encodeURIComponent('' + searchType) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetReportTrendingQuotes(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetReportTrendingQuotes(<any>response_);
                        } catch (e) {
                            return <Observable<QuoteTrendingReportOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<QuoteTrendingReportOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetReportTrendingQuotes(response: HttpResponseBase): Observable<QuoteTrendingReportOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(QuoteTrendingReportOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<QuoteTrendingReportOutput[]>([]);
    }

    /**
     * @param partnerId (optional)
     * @param providerId (optional)
     * @return Success
     */
    getQuotesDashboard(partnerId: number | undefined, providerId: number | undefined): Observable<QuotesDashboardOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetQuotesDashboard?';
        if (partnerId === null) throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined) url_ += 'partnerId=' + encodeURIComponent('' + partnerId) + '&';
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'providerId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetQuotesDashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetQuotesDashboard(<any>response_);
                        } catch (e) {
                            return <Observable<QuotesDashboardOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<QuotesDashboardOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetQuotesDashboard(response: HttpResponseBase): Observable<QuotesDashboardOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(QuotesDashboardOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<QuotesDashboardOutput[]>([]);
    }

    /**
     * @param supervisorId (optional)
     * @return Success
     */
    getSalesSupportUsersDashboard(supervisorId: number | undefined): Observable<SalesSupportUsersDashboardOutput[]> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetSalesSupportUsersDashboard?';
        if (supervisorId === null) throw new Error("The parameter 'supervisorId' cannot be null.");
        else if (supervisorId !== undefined) url_ += 'supervisorId=' + encodeURIComponent('' + supervisorId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetSalesSupportUsersDashboard(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetSalesSupportUsersDashboard(<any>response_);
                        } catch (e) {
                            return <Observable<SalesSupportUsersDashboardOutput[]>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<SalesSupportUsersDashboardOutput[]>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetSalesSupportUsersDashboard(response: HttpResponseBase): Observable<SalesSupportUsersDashboardOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = [] as any;
                        for (let item of resultData200) result200.push(SalesSupportUsersDashboardOutput.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<SalesSupportUsersDashboardOutput[]>([]);
    }

    /**
     * @param quoteId (optional)
     * @return Success
     */
    getQuoteEstimatedValue(quoteId: number | undefined): Observable<QuoteEstimateOutput> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetQuoteEstimatedValue?';
        if (quoteId === null) throw new Error("The parameter 'quoteId' cannot be null.");
        else if (quoteId !== undefined) url_ += 'quoteId=' + encodeURIComponent('' + quoteId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetQuoteEstimatedValue(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetQuoteEstimatedValue(<any>response_);
                        } catch (e) {
                            return <Observable<QuoteEstimateOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<QuoteEstimateOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetQuoteEstimatedValue(response: HttpResponseBase): Observable<QuoteEstimateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = QuoteEstimateOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<QuoteEstimateOutput>(<any>null);
    }

    /**
     * @param loggedInUser (optional)
     * @param quoteNumber (optional)
     * @param customerName (optional)
     * @param partnerName (optional)
     * @param salesAgentName (optional)
     * @param agentEmailAddress (optional)
     * @param agentPhoneNumber (optional)
     * @param providerName (optional)
     * @param quoteProviderId (optional)
     * @param quoteUrl (optional)
     * @param quoteId (optional)
     * @param excludedProductList (optional)
     * @param providerId (optional)
     * @return Success
     */
    getQuoteEmailToProviderTemplate(
        loggedInUser: string | undefined,
        quoteNumber: string | undefined,
        customerName: string | undefined,
        partnerName: string | undefined,
        salesAgentName: string | undefined,
        agentEmailAddress: string | undefined,
        agentPhoneNumber: string | undefined,
        providerName: string | undefined,
        quoteProviderId: number | undefined,
        quoteUrl: string | undefined,
        quoteId: number | undefined,
        excludedProductList: string[] | undefined,
        providerId: number | undefined
    ): Observable<QuoteEmailOutput> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetQuoteEmailToProviderTemplate?';
        if (loggedInUser === null) throw new Error("The parameter 'loggedInUser' cannot be null.");
        else if (loggedInUser !== undefined) url_ += 'LoggedInUser=' + encodeURIComponent('' + loggedInUser) + '&';
        if (quoteNumber === null) throw new Error("The parameter 'quoteNumber' cannot be null.");
        else if (quoteNumber !== undefined) url_ += 'QuoteNumber=' + encodeURIComponent('' + quoteNumber) + '&';
        if (customerName === null) throw new Error("The parameter 'customerName' cannot be null.");
        else if (customerName !== undefined) url_ += 'CustomerName=' + encodeURIComponent('' + customerName) + '&';
        if (partnerName === null) throw new Error("The parameter 'partnerName' cannot be null.");
        else if (partnerName !== undefined) url_ += 'PartnerName=' + encodeURIComponent('' + partnerName) + '&';
        if (salesAgentName === null) throw new Error("The parameter 'salesAgentName' cannot be null.");
        else if (salesAgentName !== undefined) url_ += 'SalesAgentName=' + encodeURIComponent('' + salesAgentName) + '&';
        if (agentEmailAddress === null) throw new Error("The parameter 'agentEmailAddress' cannot be null.");
        else if (agentEmailAddress !== undefined) url_ += 'AgentEmailAddress=' + encodeURIComponent('' + agentEmailAddress) + '&';
        if (agentPhoneNumber === null) throw new Error("The parameter 'agentPhoneNumber' cannot be null.");
        else if (agentPhoneNumber !== undefined) url_ += 'AgentPhoneNumber=' + encodeURIComponent('' + agentPhoneNumber) + '&';
        if (providerName === null) throw new Error("The parameter 'providerName' cannot be null.");
        else if (providerName !== undefined) url_ += 'ProviderName=' + encodeURIComponent('' + providerName) + '&';
        if (quoteProviderId === null) throw new Error("The parameter 'quoteProviderId' cannot be null.");
        else if (quoteProviderId !== undefined) url_ += 'QuoteProviderId=' + encodeURIComponent('' + quoteProviderId) + '&';
        if (quoteUrl === null) throw new Error("The parameter 'quoteUrl' cannot be null.");
        else if (quoteUrl !== undefined) url_ += 'QuoteUrl=' + encodeURIComponent('' + quoteUrl) + '&';
        if (quoteId === null) throw new Error("The parameter 'quoteId' cannot be null.");
        else if (quoteId !== undefined) url_ += 'QuoteId=' + encodeURIComponent('' + quoteId) + '&';
        if (excludedProductList === null) throw new Error("The parameter 'excludedProductList' cannot be null.");
        else if (excludedProductList !== undefined)
            excludedProductList &&
                excludedProductList.forEach((item) => {
                    url_ += 'ExcludedProductList=' + encodeURIComponent('' + item) + '&';
                });
        if (providerId === null) throw new Error("The parameter 'providerId' cannot be null.");
        else if (providerId !== undefined) url_ += 'ProviderId=' + encodeURIComponent('' + providerId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetQuoteEmailToProviderTemplate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetQuoteEmailToProviderTemplate(<any>response_);
                        } catch (e) {
                            return <Observable<QuoteEmailOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<QuoteEmailOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetQuoteEmailToProviderTemplate(response: HttpResponseBase): Observable<QuoteEmailOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = QuoteEmailOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<QuoteEmailOutput>(<any>null);
    }

    /**
     * @param loggedInUser (optional)
     * @param quoteNumber (optional)
     * @param customerName (optional)
     * @param partnerName (optional)
     * @param salesAgentName (optional)
     * @param priceRequestNotes (optional)
     * @param quoteUrl (optional)
     * @param requestPaperworkUrl (optional)
     * @param quoteId (optional)
     * @return Success
     */
    getQuoteEmailToPartnerTemplate(
        loggedInUser: string | undefined,
        quoteNumber: string | undefined,
        customerName: string | undefined,
        partnerName: string | undefined,
        salesAgentName: string | undefined,
        priceRequestNotes: string | undefined,
        quoteUrl: string | undefined,
        requestPaperworkUrl: string | undefined,
        quoteId: number | undefined
    ): Observable<QuoteEmailOutput> {
        let url_ = this.baseUrl + '/api/services/app/Quotes/GetQuoteEmailToPartnerTemplate?';
        if (loggedInUser === null) throw new Error("The parameter 'loggedInUser' cannot be null.");
        else if (loggedInUser !== undefined) url_ += 'LoggedInUser=' + encodeURIComponent('' + loggedInUser) + '&';
        if (quoteNumber === null) throw new Error("The parameter 'quoteNumber' cannot be null.");
        else if (quoteNumber !== undefined) url_ += 'QuoteNumber=' + encodeURIComponent('' + quoteNumber) + '&';
        if (customerName === null) throw new Error("The parameter 'customerName' cannot be null.");
        else if (customerName !== undefined) url_ += 'CustomerName=' + encodeURIComponent('' + customerName) + '&';
        if (partnerName === null) throw new Error("The parameter 'partnerName' cannot be null.");
        else if (partnerName !== undefined) url_ += 'PartnerName=' + encodeURIComponent('' + partnerName) + '&';
        if (salesAgentName === null) throw new Error("The parameter 'salesAgentName' cannot be null.");
        else if (salesAgentName !== undefined) url_ += 'SalesAgentName=' + encodeURIComponent('' + salesAgentName) + '&';
        if (priceRequestNotes === null) throw new Error("The parameter 'priceRequestNotes' cannot be null.");
        else if (priceRequestNotes !== undefined) url_ += 'PriceRequestNotes=' + encodeURIComponent('' + priceRequestNotes) + '&';
        if (quoteUrl === null) throw new Error("The parameter 'quoteUrl' cannot be null.");
        else if (quoteUrl !== undefined) url_ += 'QuoteUrl=' + encodeURIComponent('' + quoteUrl) + '&';
        if (requestPaperworkUrl === null) throw new Error("The parameter 'requestPaperworkUrl' cannot be null.");
        else if (requestPaperworkUrl !== undefined) url_ += 'RequestPaperworkUrl=' + encodeURIComponent('' + requestPaperworkUrl) + '&';
        if (quoteId === null) throw new Error("The parameter 'quoteId' cannot be null.");
        else if (quoteId !== undefined) url_ += 'QuoteId=' + encodeURIComponent('' + quoteId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            withCredentials: true,
            headers: new HttpHeaders({
                Accept: 'text/plain',
            }),
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetQuoteEmailToPartnerTemplate(response_);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetQuoteEmailToPartnerTemplate(<any>response_);
                        } catch (e) {
                            return <Observable<QuoteEmailOutput>>(<any>_observableThrow(e));
                        }
                    } else return <Observable<QuoteEmailOutput>>(<any>_observableThrow(response_));
                })
            );
    }

    protected processGetQuoteEmailToPartnerTemplate(response: HttpResponseBase): Observable<QuoteEmailOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body : (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    let result200: any = null;
                    let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = QuoteEmailOutput.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<QuoteEmailOutput>(<any>null);
    }
}

export class ActiveQuoteCountAging implements IActiveQuoteCountAging {
    thirty: number;
    sixty: number;
    ninety: number;

    constructor(data?: IActiveQuoteCountAging) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.thirty = _data['thirty'];
            this.sixty = _data['sixty'];
            this.ninety = _data['ninety'];
        }
    }

    static fromJS(data: any): ActiveQuoteCountAging {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveQuoteCountAging();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['thirty'] = this.thirty;
        data['sixty'] = this.sixty;
        data['ninety'] = this.ninety;
        return data;
    }

    clone(): ActiveQuoteCountAging {
        const json = this.toJSON();
        let result = new ActiveQuoteCountAging();
        result.init(json);
        return result;
    }
}

export interface IActiveQuoteCountAging {
    thirty: number;
    sixty: number;
    ninety: number;
}

export class ContractTerm implements IContractTerm {
    tenantId: number | undefined;
    name: string;
    multiplier: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IContractTerm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.multiplier = _data['multiplier'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): ContractTerm {
        data = typeof data === 'object' ? data : {};
        let result = new ContractTerm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['multiplier'] = this.multiplier;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): ContractTerm {
        const json = this.toJSON();
        let result = new ContractTerm();
        result.init(json);
        return result;
    }
}

export interface IContractTerm {
    tenantId: number | undefined;
    name: string;
    multiplier: number;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class CreateOrUpdateQuoteInput implements ICreateOrUpdateQuoteInput {
    quote: QuoteEditDto;
    ticketId: number;

    constructor(data?: ICreateOrUpdateQuoteInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quote = _data['quote'] ? QuoteEditDto.fromJS(_data['quote']) : <any>undefined;
            this.ticketId = _data['ticketId'];
        }
    }

    static fromJS(data: any): CreateOrUpdateQuoteInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateQuoteInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['quote'] = this.quote ? this.quote.toJSON() : <any>undefined;
        data['ticketId'] = this.ticketId;
        return data;
    }

    clone(): CreateOrUpdateQuoteInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateQuoteInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateQuoteInput {
    quote: QuoteEditDto;
    ticketId: number;
}

export class CreateOrUpdateQuoteUserInput implements ICreateOrUpdateQuoteUserInput {
    quoteId: number;
    userId: number;

    constructor(data?: ICreateOrUpdateQuoteUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteId = _data['quoteId'];
            this.userId = _data['userId'];
        }
    }

    static fromJS(data: any): CreateOrUpdateQuoteUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateQuoteUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['quoteId'] = this.quoteId;
        data['userId'] = this.userId;
        return data;
    }

    clone(): CreateOrUpdateQuoteUserInput {
        const json = this.toJSON();
        let result = new CreateOrUpdateQuoteUserInput();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateQuoteUserInput {
    quoteId: number;
    userId: number;
}

export class GetLocationListForQuoteDto implements IGetLocationListForQuoteDto {
    customerLocationId: number;
    customerLocation: CustomerLocationDto;
    productList: ProductListForQuoteDto[] | undefined;

    constructor(data?: IGetLocationListForQuoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerLocationId = _data['customerLocationId'];
            this.customerLocation = _data['customerLocation'] ? CustomerLocationDto.fromJS(_data['customerLocation']) : <any>undefined;
            if (Array.isArray(_data['productList'])) {
                this.productList = [] as any;
                for (let item of _data['productList']) this.productList.push(ProductListForQuoteDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLocationListForQuoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetLocationListForQuoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['customerLocationId'] = this.customerLocationId;
        data['customerLocation'] = this.customerLocation ? this.customerLocation.toJSON() : <any>undefined;
        if (Array.isArray(this.productList)) {
            data['productList'] = [];
            for (let item of this.productList) data['productList'].push(item.toJSON());
        }
        return data;
    }

    clone(): GetLocationListForQuoteDto {
        const json = this.toJSON();
        let result = new GetLocationListForQuoteDto();
        result.init(json);
        return result;
    }
}

export interface IGetLocationListForQuoteDto {
    customerLocationId: number;
    customerLocation: CustomerLocationDto;
    productList: ProductListForQuoteDto[] | undefined;
}

export class IQuoteEmailBodyBuilder implements IIQuoteEmailBodyBuilder {
    constructor(data?: IIQuoteEmailBodyBuilder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {}

    static fromJS(data: any): IQuoteEmailBodyBuilder {
        data = typeof data === 'object' ? data : {};
        let result = new IQuoteEmailBodyBuilder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): IQuoteEmailBodyBuilder {
        const json = this.toJSON();
        let result = new IQuoteEmailBodyBuilder();
        result.init(json);
        return result;
    }
}

export interface IIQuoteEmailBodyBuilder {}

export class OpenQuotesAgingDashboardOutput implements IOpenQuotesAgingDashboardOutput {
    name: string | undefined;
    one: number;
    three: number;
    five: number;
    sixPlus: number;

    constructor(data?: IOpenQuotesAgingDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.one = _data['one'];
            this.three = _data['three'];
            this.five = _data['five'];
            this.sixPlus = _data['sixPlus'];
        }
    }

    static fromJS(data: any): OpenQuotesAgingDashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new OpenQuotesAgingDashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['one'] = this.one;
        data['three'] = this.three;
        data['five'] = this.five;
        data['sixPlus'] = this.sixPlus;
        return data;
    }

    clone(): OpenQuotesAgingDashboardOutput {
        const json = this.toJSON();
        let result = new OpenQuotesAgingDashboardOutput();
        result.init(json);
        return result;
    }
}

export interface IOpenQuotesAgingDashboardOutput {
    name: string | undefined;
    one: number;
    three: number;
    five: number;
    sixPlus: number;
}

export class OutputReportExecSummPartnerQuotes implements IOutputReportExecSummPartnerQuotes {
    providerId: number;
    provider: string | undefined;
    quotedAmount: number[] | undefined;
    date: string[] | undefined;
    selectedDate: string[] | undefined;

    constructor(data?: IOutputReportExecSummPartnerQuotes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerId = _data['providerId'];
            this.provider = _data['provider'];
            if (Array.isArray(_data['quotedAmount'])) {
                this.quotedAmount = [] as any;
                for (let item of _data['quotedAmount']) this.quotedAmount.push(item);
            }
            if (Array.isArray(_data['date'])) {
                this.date = [] as any;
                for (let item of _data['date']) this.date.push(item);
            }
            if (Array.isArray(_data['selectedDate'])) {
                this.selectedDate = [] as any;
                for (let item of _data['selectedDate']) this.selectedDate.push(item);
            }
        }
    }

    static fromJS(data: any): OutputReportExecSummPartnerQuotes {
        data = typeof data === 'object' ? data : {};
        let result = new OutputReportExecSummPartnerQuotes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['providerId'] = this.providerId;
        data['provider'] = this.provider;
        if (Array.isArray(this.quotedAmount)) {
            data['quotedAmount'] = [];
            for (let item of this.quotedAmount) data['quotedAmount'].push(item);
        }
        if (Array.isArray(this.date)) {
            data['date'] = [];
            for (let item of this.date) data['date'].push(item);
        }
        if (Array.isArray(this.selectedDate)) {
            data['selectedDate'] = [];
            for (let item of this.selectedDate) data['selectedDate'].push(item);
        }
        return data;
    }

    clone(): OutputReportExecSummPartnerQuotes {
        const json = this.toJSON();
        let result = new OutputReportExecSummPartnerQuotes();
        result.init(json);
        return result;
    }
}

export interface IOutputReportExecSummPartnerQuotes {
    providerId: number;
    provider: string | undefined;
    quotedAmount: number[] | undefined;
    date: string[] | undefined;
    selectedDate: string[] | undefined;
}

export class OutputReportExecSummProviderQuotes implements IOutputReportExecSummProviderQuotes {
    partnerId: number;
    partner: string | undefined;
    quotedAmount: number[] | undefined;
    date: string[] | undefined;
    selectedDate: string[] | undefined;

    constructor(data?: IOutputReportExecSummProviderQuotes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partnerId = _data['partnerId'];
            this.partner = _data['partner'];
            if (Array.isArray(_data['quotedAmount'])) {
                this.quotedAmount = [] as any;
                for (let item of _data['quotedAmount']) this.quotedAmount.push(item);
            }
            if (Array.isArray(_data['date'])) {
                this.date = [] as any;
                for (let item of _data['date']) this.date.push(item);
            }
            if (Array.isArray(_data['selectedDate'])) {
                this.selectedDate = [] as any;
                for (let item of _data['selectedDate']) this.selectedDate.push(item);
            }
        }
    }

    static fromJS(data: any): OutputReportExecSummProviderQuotes {
        data = typeof data === 'object' ? data : {};
        let result = new OutputReportExecSummProviderQuotes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['partnerId'] = this.partnerId;
        data['partner'] = this.partner;
        if (Array.isArray(this.quotedAmount)) {
            data['quotedAmount'] = [];
            for (let item of this.quotedAmount) data['quotedAmount'].push(item);
        }
        if (Array.isArray(this.date)) {
            data['date'] = [];
            for (let item of this.date) data['date'].push(item);
        }
        if (Array.isArray(this.selectedDate)) {
            data['selectedDate'] = [];
            for (let item of this.selectedDate) data['selectedDate'].push(item);
        }
        return data;
    }

    clone(): OutputReportExecSummProviderQuotes {
        const json = this.toJSON();
        let result = new OutputReportExecSummProviderQuotes();
        result.init(json);
        return result;
    }
}

export interface IOutputReportExecSummProviderQuotes {
    partnerId: number;
    partner: string | undefined;
    quotedAmount: number[] | undefined;
    date: string[] | undefined;
    selectedDate: string[] | undefined;
}

export class ProductListForQuote implements IProductListForQuote {
    productId: number;
    productName: string | undefined;
    providerProduct: QuoteProviderProductEditDto;
    locationDetail: QuoteLocationEditDto[] | undefined;
    isSelected: boolean;

    constructor(data?: IProductListForQuote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data['productId'];
            this.productName = _data['productName'];
            this.providerProduct = _data['providerProduct'] ? QuoteProviderProductEditDto.fromJS(_data['providerProduct']) : <any>undefined;
            if (Array.isArray(_data['locationDetail'])) {
                this.locationDetail = [] as any;
                for (let item of _data['locationDetail']) this.locationDetail.push(QuoteLocationEditDto.fromJS(item));
            }
            this.isSelected = _data['isSelected'];
        }
    }

    static fromJS(data: any): ProductListForQuote {
        data = typeof data === 'object' ? data : {};
        let result = new ProductListForQuote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['productId'] = this.productId;
        data['productName'] = this.productName;
        data['providerProduct'] = this.providerProduct ? this.providerProduct.toJSON() : <any>undefined;
        if (Array.isArray(this.locationDetail)) {
            data['locationDetail'] = [];
            for (let item of this.locationDetail) data['locationDetail'].push(item.toJSON());
        }
        data['isSelected'] = this.isSelected;
        return data;
    }

    clone(): ProductListForQuote {
        const json = this.toJSON();
        let result = new ProductListForQuote();
        result.init(json);
        return result;
    }
}

export interface IProductListForQuote {
    productId: number;
    productName: string | undefined;
    providerProduct: QuoteProviderProductEditDto;
    locationDetail: QuoteLocationEditDto[] | undefined;
    isSelected: boolean;
}

export class ProductListForQuoteDto implements IProductListForQuoteDto {
    productId: number;
    providerList: ProviderDetailsForQuoteDto[] | undefined;

    constructor(data?: IProductListForQuoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data['productId'];
            if (Array.isArray(_data['providerList'])) {
                this.providerList = [] as any;
                for (let item of _data['providerList']) this.providerList.push(ProviderDetailsForQuoteDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductListForQuoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductListForQuoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['productId'] = this.productId;
        if (Array.isArray(this.providerList)) {
            data['providerList'] = [];
            for (let item of this.providerList) data['providerList'].push(item.toJSON());
        }
        return data;
    }

    clone(): ProductListForQuoteDto {
        const json = this.toJSON();
        let result = new ProductListForQuoteDto();
        result.init(json);
        return result;
    }
}

export interface IProductListForQuoteDto {
    productId: number;
    providerList: ProviderDetailsForQuoteDto[] | undefined;
}

export class ProviderDetailsForQuoteDto implements IProviderDetailsForQuoteDto {
    providerId: number;

    constructor(data?: IProviderDetailsForQuoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerId = _data['providerId'];
        }
    }

    static fromJS(data: any): ProviderDetailsForQuoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderDetailsForQuoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['providerId'] = this.providerId;
        return data;
    }

    clone(): ProviderDetailsForQuoteDto {
        const json = this.toJSON();
        let result = new ProviderDetailsForQuoteDto();
        result.init(json);
        return result;
    }
}

export interface IProviderDetailsForQuoteDto {
    providerId: number;
}

export class ProviderListForProductQuoteDto implements IProviderListForProductQuoteDto {
    id: number;
    name: string | undefined;
    imageSourceUrl: string | undefined;

    constructor(data?: IProviderListForProductQuoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.imageSourceUrl = _data['imageSourceUrl'];
        }
    }

    static fromJS(data: any): ProviderListForProductQuoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderListForProductQuoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['imageSourceUrl'] = this.imageSourceUrl;
        return data;
    }

    clone(): ProviderListForProductQuoteDto {
        const json = this.toJSON();
        let result = new ProviderListForProductQuoteDto();
        result.init(json);
        return result;
    }
}

export interface IProviderListForProductQuoteDto {
    id: number;
    name: string | undefined;
    imageSourceUrl: string | undefined;
}

export class ProviderListForQuote implements IProviderListForQuote {
    id: number;
    providerId: number;
    name: string | undefined;
    productList: ProductListForQuote[] | undefined;

    constructor(data?: IProviderListForQuote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.providerId = _data['providerId'];
            this.name = _data['name'];
            if (Array.isArray(_data['productList'])) {
                this.productList = [] as any;
                for (let item of _data['productList']) this.productList.push(ProductListForQuote.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProviderListForQuote {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderListForQuote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['providerId'] = this.providerId;
        data['name'] = this.name;
        if (Array.isArray(this.productList)) {
            data['productList'] = [];
            for (let item of this.productList) data['productList'].push(item.toJSON());
        }
        return data;
    }

    clone(): ProviderListForQuote {
        const json = this.toJSON();
        let result = new ProviderListForQuote();
        result.init(json);
        return result;
    }
}

export interface IProviderListForQuote {
    id: number;
    providerId: number;
    name: string | undefined;
    productList: ProductListForQuote[] | undefined;
}

export class ProvidersListForProductQuoteDto implements IProvidersListForProductQuoteDto {
    productId: number;
    productName: string | undefined;
    providerList: ProviderListForProductQuoteDto[] | undefined;

    constructor(data?: IProvidersListForProductQuoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productId = _data['productId'];
            this.productName = _data['productName'];
            if (Array.isArray(_data['providerList'])) {
                this.providerList = [] as any;
                for (let item of _data['providerList']) this.providerList.push(ProviderListForProductQuoteDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProvidersListForProductQuoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProvidersListForProductQuoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['productId'] = this.productId;
        data['productName'] = this.productName;
        if (Array.isArray(this.providerList)) {
            data['providerList'] = [];
            for (let item of this.providerList) data['providerList'].push(item.toJSON());
        }
        return data;
    }

    clone(): ProvidersListForProductQuoteDto {
        const json = this.toJSON();
        let result = new ProvidersListForProductQuoteDto();
        result.init(json);
        return result;
    }
}

export interface IProvidersListForProductQuoteDto {
    productId: number;
    productName: string | undefined;
    providerList: ProviderListForProductQuoteDto[] | undefined;
}

export class Quote implements IQuote {
    tenantId: number | undefined;
    quoteNumber: string;
    partnerId: number;
    partner: Partner;
    salesAgentId: number;
    salesAgent: User;
    salesEngineerId: number | undefined;
    salesEngineer: User;
    customerId: number;
    customer: Customer;
    name: string | undefined;
    description: string | undefined;
    quoteStageTypeId: number;
    quoteStageType: QuoteStageType;
    createAttribJson: string | undefined;
    internalSalesAgentId: number | undefined;
    salesCampaignId: number | undefined;
    salesCampaign: SalesCampaignEntity;
    internalSalesAgent: User;
    quoteUsers: QuoteUser[] | undefined;
    quoteLocations: QuoteLocation[] | undefined;
    quoteContractTerms: QuoteContractTerm[] | undefined;
    quoteProviders: QuoteProvider[] | undefined;
    quoteProducts: QuoteProduct[] | undefined;
    quoteProviderProducts: QuoteProviderProduct[] | undefined;
    quotePriceDetails: QuotePriceDetail[] | undefined;
    quotePriceDetailsContracts: QuotePriceDetailContract[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IQuote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.quoteNumber = _data['quoteNumber'];
            this.partnerId = _data['partnerId'];
            this.partner = _data['partner'] ? Partner.fromJS(_data['partner']) : <any>undefined;
            this.salesAgentId = _data['salesAgentId'];
            this.salesAgent = _data['salesAgent'] ? User.fromJS(_data['salesAgent']) : <any>undefined;
            this.salesEngineerId = _data['salesEngineerId'];
            this.salesEngineer = _data['salesEngineer'] ? User.fromJS(_data['salesEngineer']) : <any>undefined;
            this.customerId = _data['customerId'];
            this.customer = _data['customer'] ? Customer.fromJS(_data['customer']) : <any>undefined;
            this.name = _data['name'];
            this.description = _data['description'];
            this.quoteStageTypeId = _data['quoteStageTypeId'];
            this.quoteStageType = _data['quoteStageType'] ? QuoteStageType.fromJS(_data['quoteStageType']) : <any>undefined;
            this.createAttribJson = _data['createAttribJson'];
            this.internalSalesAgentId = _data['internalSalesAgentId'];
            this.salesCampaignId = _data['salesCampaignId'];
            this.salesCampaign = _data['salesCampaign'] ? SalesCampaignEntity.fromJS(_data['salesCampaign']) : <any>undefined;
            this.internalSalesAgent = _data['internalSalesAgent'] ? User.fromJS(_data['internalSalesAgent']) : <any>undefined;
            if (Array.isArray(_data['quoteUsers'])) {
                this.quoteUsers = [] as any;
                for (let item of _data['quoteUsers']) this.quoteUsers.push(QuoteUser.fromJS(item));
            }
            if (Array.isArray(_data['quoteLocations'])) {
                this.quoteLocations = [] as any;
                for (let item of _data['quoteLocations']) this.quoteLocations.push(QuoteLocation.fromJS(item));
            }
            if (Array.isArray(_data['quoteContractTerms'])) {
                this.quoteContractTerms = [] as any;
                for (let item of _data['quoteContractTerms']) this.quoteContractTerms.push(QuoteContractTerm.fromJS(item));
            }
            if (Array.isArray(_data['quoteProviders'])) {
                this.quoteProviders = [] as any;
                for (let item of _data['quoteProviders']) this.quoteProviders.push(QuoteProvider.fromJS(item));
            }
            if (Array.isArray(_data['quoteProducts'])) {
                this.quoteProducts = [] as any;
                for (let item of _data['quoteProducts']) this.quoteProducts.push(QuoteProduct.fromJS(item));
            }
            if (Array.isArray(_data['quoteProviderProducts'])) {
                this.quoteProviderProducts = [] as any;
                for (let item of _data['quoteProviderProducts']) this.quoteProviderProducts.push(QuoteProviderProduct.fromJS(item));
            }
            if (Array.isArray(_data['quotePriceDetails'])) {
                this.quotePriceDetails = [] as any;
                for (let item of _data['quotePriceDetails']) this.quotePriceDetails.push(QuotePriceDetail.fromJS(item));
            }
            if (Array.isArray(_data['quotePriceDetailsContracts'])) {
                this.quotePriceDetailsContracts = [] as any;
                for (let item of _data['quotePriceDetailsContracts'])
                    this.quotePriceDetailsContracts.push(QuotePriceDetailContract.fromJS(item));
            }
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): Quote {
        data = typeof data === 'object' ? data : {};
        let result = new Quote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['quoteNumber'] = this.quoteNumber;
        data['partnerId'] = this.partnerId;
        data['partner'] = this.partner ? this.partner.toJSON() : <any>undefined;
        data['salesAgentId'] = this.salesAgentId;
        data['salesAgent'] = this.salesAgent ? this.salesAgent.toJSON() : <any>undefined;
        data['salesEngineerId'] = this.salesEngineerId;
        data['salesEngineer'] = this.salesEngineer ? this.salesEngineer.toJSON() : <any>undefined;
        data['customerId'] = this.customerId;
        data['customer'] = this.customer ? this.customer.toJSON() : <any>undefined;
        data['name'] = this.name;
        data['description'] = this.description;
        data['quoteStageTypeId'] = this.quoteStageTypeId;
        data['quoteStageType'] = this.quoteStageType ? this.quoteStageType.toJSON() : <any>undefined;
        data['createAttribJson'] = this.createAttribJson;
        data['internalSalesAgentId'] = this.internalSalesAgentId;
        data['salesCampaignId'] = this.salesCampaignId;
        data['salesCampaign'] = this.salesCampaign ? this.salesCampaign.toJSON() : <any>undefined;
        data['internalSalesAgent'] = this.internalSalesAgent ? this.internalSalesAgent.toJSON() : <any>undefined;
        if (Array.isArray(this.quoteUsers)) {
            data['quoteUsers'] = [];
            for (let item of this.quoteUsers) data['quoteUsers'].push(item.toJSON());
        }
        if (Array.isArray(this.quoteLocations)) {
            data['quoteLocations'] = [];
            for (let item of this.quoteLocations) data['quoteLocations'].push(item.toJSON());
        }
        if (Array.isArray(this.quoteContractTerms)) {
            data['quoteContractTerms'] = [];
            for (let item of this.quoteContractTerms) data['quoteContractTerms'].push(item.toJSON());
        }
        if (Array.isArray(this.quoteProviders)) {
            data['quoteProviders'] = [];
            for (let item of this.quoteProviders) data['quoteProviders'].push(item.toJSON());
        }
        if (Array.isArray(this.quoteProducts)) {
            data['quoteProducts'] = [];
            for (let item of this.quoteProducts) data['quoteProducts'].push(item.toJSON());
        }
        if (Array.isArray(this.quoteProviderProducts)) {
            data['quoteProviderProducts'] = [];
            for (let item of this.quoteProviderProducts) data['quoteProviderProducts'].push(item.toJSON());
        }
        if (Array.isArray(this.quotePriceDetails)) {
            data['quotePriceDetails'] = [];
            for (let item of this.quotePriceDetails) data['quotePriceDetails'].push(item.toJSON());
        }
        if (Array.isArray(this.quotePriceDetailsContracts)) {
            data['quotePriceDetailsContracts'] = [];
            for (let item of this.quotePriceDetailsContracts) data['quotePriceDetailsContracts'].push(item.toJSON());
        }
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): Quote {
        const json = this.toJSON();
        let result = new Quote();
        result.init(json);
        return result;
    }
}

export interface IQuote {
    tenantId: number | undefined;
    quoteNumber: string;
    partnerId: number;
    partner: Partner;
    salesAgentId: number;
    salesAgent: User;
    salesEngineerId: number | undefined;
    salesEngineer: User;
    customerId: number;
    customer: Customer;
    name: string | undefined;
    description: string | undefined;
    quoteStageTypeId: number;
    quoteStageType: QuoteStageType;
    createAttribJson: string | undefined;
    internalSalesAgentId: number | undefined;
    salesCampaignId: number | undefined;
    salesCampaign: SalesCampaignEntity;
    internalSalesAgent: User;
    quoteUsers: QuoteUser[] | undefined;
    quoteLocations: QuoteLocation[] | undefined;
    quoteContractTerms: QuoteContractTerm[] | undefined;
    quoteProviders: QuoteProvider[] | undefined;
    quoteProducts: QuoteProduct[] | undefined;
    quoteProviderProducts: QuoteProviderProduct[] | undefined;
    quotePriceDetails: QuotePriceDetail[] | undefined;
    quotePriceDetailsContracts: QuotePriceDetailContract[] | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class QuoteContractTerm implements IQuoteContractTerm {
    tenantId: number | undefined;
    quoteId: number;
    quote: Quote;
    contractTermId: number;
    contractTerm: ContractTerm;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    quotePriceDetailContracts: QuotePriceDetailContract[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IQuoteContractTerm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.quoteId = _data['quoteId'];
            this.quote = _data['quote'] ? Quote.fromJS(_data['quote']) : <any>undefined;
            this.contractTermId = _data['contractTermId'];
            this.contractTerm = _data['contractTerm'] ? ContractTerm.fromJS(_data['contractTerm']) : <any>undefined;
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            if (Array.isArray(_data['quotePriceDetailContracts'])) {
                this.quotePriceDetailContracts = [] as any;
                for (let item of _data['quotePriceDetailContracts'])
                    this.quotePriceDetailContracts.push(QuotePriceDetailContract.fromJS(item));
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): QuoteContractTerm {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteContractTerm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['quoteId'] = this.quoteId;
        data['quote'] = this.quote ? this.quote.toJSON() : <any>undefined;
        data['contractTermId'] = this.contractTermId;
        data['contractTerm'] = this.contractTerm ? this.contractTerm.toJSON() : <any>undefined;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        if (Array.isArray(this.quotePriceDetailContracts)) {
            data['quotePriceDetailContracts'] = [];
            for (let item of this.quotePriceDetailContracts) data['quotePriceDetailContracts'].push(item.toJSON());
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): QuoteContractTerm {
        const json = this.toJSON();
        let result = new QuoteContractTerm();
        result.init(json);
        return result;
    }
}

export interface IQuoteContractTerm {
    tenantId: number | undefined;
    quoteId: number;
    quote: Quote;
    contractTermId: number;
    contractTerm: ContractTerm;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    quotePriceDetailContracts: QuotePriceDetailContract[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class QuoteContractTermEditDto implements IQuoteContractTermEditDto {
    quoteId: number;
    contractTermId: number;
    contractTerm: ContractTermListDto;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IQuoteContractTermEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteId = _data['quoteId'];
            this.contractTermId = _data['contractTermId'];
            this.contractTerm = _data['contractTerm'] ? ContractTermListDto.fromJS(_data['contractTerm']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): QuoteContractTermEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteContractTermEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['quoteId'] = this.quoteId;
        data['contractTermId'] = this.contractTermId;
        data['contractTerm'] = this.contractTerm ? this.contractTerm.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): QuoteContractTermEditDto {
        const json = this.toJSON();
        let result = new QuoteContractTermEditDto();
        result.init(json);
        return result;
    }
}

export interface IQuoteContractTermEditDto {
    quoteId: number;
    contractTermId: number;
    contractTerm: ContractTermListDto;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class QuoteEditDto implements IQuoteEditDto {
    quoteNumber: string | undefined;
    partnerId: number;
    partner: PartnerEditDto;
    salesAgentId: number;
    salesAgent: UserListDto;
    salesEngineerId: number | undefined;
    salesEngineer: UserListDto;
    customerId: number;
    customer: CustomerEditDto;
    name: string | undefined;
    description: string | undefined;
    quoteStageTypeId: number;
    quoteStageType: QuoteStageType;
    createAttribJson: string | undefined;
    createdByName: string | undefined;
    internalSalesAgentId: number | undefined;
    salesCampaignId: number | undefined;
    quoteUsers: QuoteUserEditDto[] | undefined;
    quoteLocations: QuoteLocationEditDto[] | undefined;
    quoteContractTerms: QuoteContractTermEditDto[] | undefined;
    quoteProviders: QuoteProviderEditDto[] | undefined;
    quoteProducts: QuoteProductEditDto[] | undefined;
    productProviderInput: ProvidersListForProductQuoteDto[] | undefined;
    locationProductProviderInput: GetLocationListForQuoteDto[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IQuoteEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteNumber = _data['quoteNumber'];
            this.partnerId = _data['partnerId'];
            this.partner = _data['partner'] ? PartnerEditDto.fromJS(_data['partner']) : <any>undefined;
            this.salesAgentId = _data['salesAgentId'];
            this.salesAgent = _data['salesAgent'] ? UserListDto.fromJS(_data['salesAgent']) : <any>undefined;
            this.salesEngineerId = _data['salesEngineerId'];
            this.salesEngineer = _data['salesEngineer'] ? UserListDto.fromJS(_data['salesEngineer']) : <any>undefined;
            this.customerId = _data['customerId'];
            this.customer = _data['customer'] ? CustomerEditDto.fromJS(_data['customer']) : <any>undefined;
            this.name = _data['name'];
            this.description = _data['description'];
            this.quoteStageTypeId = _data['quoteStageTypeId'];
            this.quoteStageType = _data['quoteStageType'] ? QuoteStageType.fromJS(_data['quoteStageType']) : <any>undefined;
            this.createAttribJson = _data['createAttribJson'];
            this.createdByName = _data['createdByName'];
            this.internalSalesAgentId = _data['internalSalesAgentId'];
            this.salesCampaignId = _data['salesCampaignId'];
            if (Array.isArray(_data['quoteUsers'])) {
                this.quoteUsers = [] as any;
                for (let item of _data['quoteUsers']) this.quoteUsers.push(QuoteUserEditDto.fromJS(item));
            }
            if (Array.isArray(_data['quoteLocations'])) {
                this.quoteLocations = [] as any;
                for (let item of _data['quoteLocations']) this.quoteLocations.push(QuoteLocationEditDto.fromJS(item));
            }
            if (Array.isArray(_data['quoteContractTerms'])) {
                this.quoteContractTerms = [] as any;
                for (let item of _data['quoteContractTerms']) this.quoteContractTerms.push(QuoteContractTermEditDto.fromJS(item));
            }
            if (Array.isArray(_data['quoteProviders'])) {
                this.quoteProviders = [] as any;
                for (let item of _data['quoteProviders']) this.quoteProviders.push(QuoteProviderEditDto.fromJS(item));
            }
            if (Array.isArray(_data['quoteProducts'])) {
                this.quoteProducts = [] as any;
                for (let item of _data['quoteProducts']) this.quoteProducts.push(QuoteProductEditDto.fromJS(item));
            }
            if (Array.isArray(_data['productProviderInput'])) {
                this.productProviderInput = [] as any;
                for (let item of _data['productProviderInput'])
                    this.productProviderInput.push(ProvidersListForProductQuoteDto.fromJS(item));
            }
            if (Array.isArray(_data['locationProductProviderInput'])) {
                this.locationProductProviderInput = [] as any;
                for (let item of _data['locationProductProviderInput'])
                    this.locationProductProviderInput.push(GetLocationListForQuoteDto.fromJS(item));
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): QuoteEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['quoteNumber'] = this.quoteNumber;
        data['partnerId'] = this.partnerId;
        data['partner'] = this.partner ? this.partner.toJSON() : <any>undefined;
        data['salesAgentId'] = this.salesAgentId;
        data['salesAgent'] = this.salesAgent ? this.salesAgent.toJSON() : <any>undefined;
        data['salesEngineerId'] = this.salesEngineerId;
        data['salesEngineer'] = this.salesEngineer ? this.salesEngineer.toJSON() : <any>undefined;
        data['customerId'] = this.customerId;
        data['customer'] = this.customer ? this.customer.toJSON() : <any>undefined;
        data['name'] = this.name;
        data['description'] = this.description;
        data['quoteStageTypeId'] = this.quoteStageTypeId;
        data['quoteStageType'] = this.quoteStageType ? this.quoteStageType.toJSON() : <any>undefined;
        data['createAttribJson'] = this.createAttribJson;
        data['createdByName'] = this.createdByName;
        data['internalSalesAgentId'] = this.internalSalesAgentId;
        data['salesCampaignId'] = this.salesCampaignId;
        if (Array.isArray(this.quoteUsers)) {
            data['quoteUsers'] = [];
            for (let item of this.quoteUsers) data['quoteUsers'].push(item.toJSON());
        }
        if (Array.isArray(this.quoteLocations)) {
            data['quoteLocations'] = [];
            for (let item of this.quoteLocations) data['quoteLocations'].push(item.toJSON());
        }
        if (Array.isArray(this.quoteContractTerms)) {
            data['quoteContractTerms'] = [];
            for (let item of this.quoteContractTerms) data['quoteContractTerms'].push(item.toJSON());
        }
        if (Array.isArray(this.quoteProviders)) {
            data['quoteProviders'] = [];
            for (let item of this.quoteProviders) data['quoteProviders'].push(item.toJSON());
        }
        if (Array.isArray(this.quoteProducts)) {
            data['quoteProducts'] = [];
            for (let item of this.quoteProducts) data['quoteProducts'].push(item.toJSON());
        }
        if (Array.isArray(this.productProviderInput)) {
            data['productProviderInput'] = [];
            for (let item of this.productProviderInput) data['productProviderInput'].push(item.toJSON());
        }
        if (Array.isArray(this.locationProductProviderInput)) {
            data['locationProductProviderInput'] = [];
            for (let item of this.locationProductProviderInput) data['locationProductProviderInput'].push(item.toJSON());
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): QuoteEditDto {
        const json = this.toJSON();
        let result = new QuoteEditDto();
        result.init(json);
        return result;
    }
}

export interface IQuoteEditDto {
    quoteNumber: string | undefined;
    partnerId: number;
    partner: PartnerEditDto;
    salesAgentId: number;
    salesAgent: UserListDto;
    salesEngineerId: number | undefined;
    salesEngineer: UserListDto;
    customerId: number;
    customer: CustomerEditDto;
    name: string | undefined;
    description: string | undefined;
    quoteStageTypeId: number;
    quoteStageType: QuoteStageType;
    createAttribJson: string | undefined;
    createdByName: string | undefined;
    internalSalesAgentId: number | undefined;
    salesCampaignId: number | undefined;
    quoteUsers: QuoteUserEditDto[] | undefined;
    quoteLocations: QuoteLocationEditDto[] | undefined;
    quoteContractTerms: QuoteContractTermEditDto[] | undefined;
    quoteProviders: QuoteProviderEditDto[] | undefined;
    quoteProducts: QuoteProductEditDto[] | undefined;
    productProviderInput: ProvidersListForProductQuoteDto[] | undefined;
    locationProductProviderInput: GetLocationListForQuoteDto[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class QuoteEmailOutput implements IQuoteEmailOutput {
    emailTemplate: string | undefined;
    warnings: string[] | undefined;

    constructor(data?: IQuoteEmailOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailTemplate = _data['emailTemplate'];
            if (Array.isArray(_data['warnings'])) {
                this.warnings = [] as any;
                for (let item of _data['warnings']) this.warnings.push(item);
            }
        }
    }

    static fromJS(data: any): QuoteEmailOutput {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteEmailOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['emailTemplate'] = this.emailTemplate;
        if (Array.isArray(this.warnings)) {
            data['warnings'] = [];
            for (let item of this.warnings) data['warnings'].push(item);
        }
        return data;
    }

    clone(): QuoteEmailOutput {
        const json = this.toJSON();
        let result = new QuoteEmailOutput();
        result.init(json);
        return result;
    }
}

export interface IQuoteEmailOutput {
    emailTemplate: string | undefined;
    warnings: string[] | undefined;
}

export class QuoteEstimateOutput implements IQuoteEstimateOutput {
    quoteEstimate: number;

    constructor(data?: IQuoteEstimateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteEstimate = _data['quoteEstimate'];
        }
    }

    static fromJS(data: any): QuoteEstimateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteEstimateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['quoteEstimate'] = this.quoteEstimate;
        return data;
    }

    clone(): QuoteEstimateOutput {
        const json = this.toJSON();
        let result = new QuoteEstimateOutput();
        result.init(json);
        return result;
    }
}

export interface IQuoteEstimateOutput {
    quoteEstimate: number;
}

export class QuoteListOutput implements IQuoteListOutput {
    quoteId: number;
    quoteName: string | undefined;
    partnerId: number;
    apid: number | undefined;
    partner: string | undefined;
    salesAgent: string | undefined;
    quoteNumber: string | undefined;
    supportSpecialist: string | undefined;
    pm: string | undefined;
    spm: string | undefined;
    customer: string | undefined;
    stage: string | undefined;
    quoteEstimate: number;
    dateReceived: moment.Moment | undefined;
    daysOld: number;
    providersList: string | undefined;
    advisorEntitlementId: number | undefined;
    product: string | undefined;
    salesCampaignId: number | undefined;
    salesCampaignName: string | undefined;
    internalSalesAgentId: number | undefined;
    internalSalesAgentName: string | undefined;
    accountManagerId: number | undefined;
    accountManagerName: string | undefined;

    constructor(data?: IQuoteListOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteId = _data['quoteId'];
            this.quoteName = _data['quoteName'];
            this.partnerId = _data['partnerId'];
            this.apid = _data['apid'];
            this.partner = _data['partner'];
            this.salesAgent = _data['salesAgent'];
            this.quoteNumber = _data['quoteNumber'];
            this.supportSpecialist = _data['supportSpecialist'];
            this.pm = _data['pm'];
            this.spm = _data['spm'];
            this.customer = _data['customer'];
            this.stage = _data['stage'];
            this.quoteEstimate = _data['quoteEstimate'];
            this.dateReceived = _data['dateReceived'] ? moment(_data['dateReceived'].toString()) : <any>undefined;
            this.daysOld = _data['daysOld'];
            this.providersList = _data['providersList'];
            this.advisorEntitlementId = _data['advisorEntitlementId'];
            this.product = _data['product'];
            this.salesCampaignId = _data['salesCampaignId'];
            this.salesCampaignName = _data['salesCampaignName'];
            this.internalSalesAgentId = _data['internalSalesAgentId'];
            this.internalSalesAgentName = _data['internalSalesAgentName'];
            this.accountManagerId = _data['accountManagerId'];
            this.accountManagerName = _data['accountManagerName'];
        }
    }

    static fromJS(data: any): QuoteListOutput {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteListOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['quoteId'] = this.quoteId;
        data['quoteName'] = this.quoteName;
        data['partnerId'] = this.partnerId;
        data['apid'] = this.apid;
        data['partner'] = this.partner;
        data['salesAgent'] = this.salesAgent;
        data['quoteNumber'] = this.quoteNumber;
        data['supportSpecialist'] = this.supportSpecialist;
        data['pm'] = this.pm;
        data['spm'] = this.spm;
        data['customer'] = this.customer;
        data['stage'] = this.stage;
        data['quoteEstimate'] = this.quoteEstimate;
        data['dateReceived'] = this.dateReceived ? this.dateReceived.toISOString() : <any>undefined;
        data['daysOld'] = this.daysOld;
        data['providersList'] = this.providersList;
        data['advisorEntitlementId'] = this.advisorEntitlementId;
        data['product'] = this.product;
        data['salesCampaignId'] = this.salesCampaignId;
        data['salesCampaignName'] = this.salesCampaignName;
        data['internalSalesAgentId'] = this.internalSalesAgentId;
        data['internalSalesAgentName'] = this.internalSalesAgentName;
        data['accountManagerId'] = this.accountManagerId;
        data['accountManagerName'] = this.accountManagerName;
        return data;
    }

    clone(): QuoteListOutput {
        const json = this.toJSON();
        let result = new QuoteListOutput();
        result.init(json);
        return result;
    }
}

export interface IQuoteListOutput {
    quoteId: number;
    quoteName: string | undefined;
    partnerId: number;
    apid: number | undefined;
    partner: string | undefined;
    salesAgent: string | undefined;
    quoteNumber: string | undefined;
    supportSpecialist: string | undefined;
    pm: string | undefined;
    spm: string | undefined;
    customer: string | undefined;
    stage: string | undefined;
    quoteEstimate: number;
    dateReceived: moment.Moment | undefined;
    daysOld: number;
    providersList: string | undefined;
    advisorEntitlementId: number | undefined;
    product: string | undefined;
    salesCampaignId: number | undefined;
    salesCampaignName: string | undefined;
    internalSalesAgentId: number | undefined;
    internalSalesAgentName: string | undefined;
    accountManagerId: number | undefined;
    accountManagerName: string | undefined;
}

export class QuoteListOutputPagedResultDto implements IQuoteListOutputPagedResultDto {
    totalCount: number;
    items: QuoteListOutput[] | undefined;

    constructor(data?: IQuoteListOutputPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data['totalCount'];
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(QuoteListOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuoteListOutputPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteListOutputPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['totalCount'] = this.totalCount;
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }

    clone(): QuoteListOutputPagedResultDto {
        const json = this.toJSON();
        let result = new QuoteListOutputPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IQuoteListOutputPagedResultDto {
    totalCount: number;
    items: QuoteListOutput[] | undefined;
}

export class QuoteLocation implements IQuoteLocation {
    tenantId: number | undefined;
    quoteId: number;
    quote: Quote;
    customerLocationId: number;
    customerLocation: CustomerLocation;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    quotePriceDetails: QuotePriceDetail[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IQuoteLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.quoteId = _data['quoteId'];
            this.quote = _data['quote'] ? Quote.fromJS(_data['quote']) : <any>undefined;
            this.customerLocationId = _data['customerLocationId'];
            this.customerLocation = _data['customerLocation'] ? CustomerLocation.fromJS(_data['customerLocation']) : <any>undefined;
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            if (Array.isArray(_data['quotePriceDetails'])) {
                this.quotePriceDetails = [] as any;
                for (let item of _data['quotePriceDetails']) this.quotePriceDetails.push(QuotePriceDetail.fromJS(item));
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): QuoteLocation {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['quoteId'] = this.quoteId;
        data['quote'] = this.quote ? this.quote.toJSON() : <any>undefined;
        data['customerLocationId'] = this.customerLocationId;
        data['customerLocation'] = this.customerLocation ? this.customerLocation.toJSON() : <any>undefined;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        if (Array.isArray(this.quotePriceDetails)) {
            data['quotePriceDetails'] = [];
            for (let item of this.quotePriceDetails) data['quotePriceDetails'].push(item.toJSON());
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): QuoteLocation {
        const json = this.toJSON();
        let result = new QuoteLocation();
        result.init(json);
        return result;
    }
}

export interface IQuoteLocation {
    tenantId: number | undefined;
    quoteId: number;
    quote: Quote;
    customerLocationId: number;
    customerLocation: CustomerLocation;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    quotePriceDetails: QuotePriceDetail[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class QuoteLocationEditDto implements IQuoteLocationEditDto {
    quoteId: number;
    customerLocationId: number;
    customerLocation: CustomerLocationDto;
    quotePriceDetailContracts: QuotePriceDetailContractDto[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IQuoteLocationEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteId = _data['quoteId'];
            this.customerLocationId = _data['customerLocationId'];
            this.customerLocation = _data['customerLocation'] ? CustomerLocationDto.fromJS(_data['customerLocation']) : <any>undefined;
            if (Array.isArray(_data['quotePriceDetailContracts'])) {
                this.quotePriceDetailContracts = [] as any;
                for (let item of _data['quotePriceDetailContracts'])
                    this.quotePriceDetailContracts.push(QuotePriceDetailContractDto.fromJS(item));
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): QuoteLocationEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteLocationEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['quoteId'] = this.quoteId;
        data['customerLocationId'] = this.customerLocationId;
        data['customerLocation'] = this.customerLocation ? this.customerLocation.toJSON() : <any>undefined;
        if (Array.isArray(this.quotePriceDetailContracts)) {
            data['quotePriceDetailContracts'] = [];
            for (let item of this.quotePriceDetailContracts) data['quotePriceDetailContracts'].push(item.toJSON());
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): QuoteLocationEditDto {
        const json = this.toJSON();
        let result = new QuoteLocationEditDto();
        result.init(json);
        return result;
    }
}

export interface IQuoteLocationEditDto {
    quoteId: number;
    customerLocationId: number;
    customerLocation: CustomerLocationDto;
    quotePriceDetailContracts: QuotePriceDetailContractDto[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class QuoteManageDto implements IQuoteManageDto {
    quoteNumber: string | undefined;
    orderId: number | undefined;
    partnerId: number;
    partner: PartnerEditDto;
    salesAgentId: number;
    salesAgent: UserListDto;
    salesEngineerId: number | undefined;
    salesEngineer: UserListDto;
    customerId: number;
    customer: CustomerEditDto;
    name: string | undefined;
    description: string | undefined;
    quoteStageTypeId: number;
    internalSalesAgentId: number | undefined;
    salesCampaignId: number | undefined;
    quoteStageType: QuoteStageType;
    createAttribJson: string | undefined;
    quoteManageEstMrc: QuoteManageEstMrcListDto[] | undefined;
    quoteUsers: QuoteUserEditDto[] | undefined;
    quoteLocations: QuoteLocationEditDto[] | undefined;
    quoteContractTerms: QuoteContractTermEditDto[] | undefined;
    quoteProviders: QuoteProviderEditDto[] | undefined;
    quoteProducts: QuoteProductEditDto[] | undefined;
    providerList: ProviderListForQuote[] | undefined;
    ticketId: number;
    ticketNumber: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IQuoteManageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteNumber = _data['quoteNumber'];
            this.orderId = _data['orderId'];
            this.partnerId = _data['partnerId'];
            this.partner = _data['partner'] ? PartnerEditDto.fromJS(_data['partner']) : <any>undefined;
            this.salesAgentId = _data['salesAgentId'];
            this.salesAgent = _data['salesAgent'] ? UserListDto.fromJS(_data['salesAgent']) : <any>undefined;
            this.salesEngineerId = _data['salesEngineerId'];
            this.salesEngineer = _data['salesEngineer'] ? UserListDto.fromJS(_data['salesEngineer']) : <any>undefined;
            this.customerId = _data['customerId'];
            this.customer = _data['customer'] ? CustomerEditDto.fromJS(_data['customer']) : <any>undefined;
            this.name = _data['name'];
            this.description = _data['description'];
            this.quoteStageTypeId = _data['quoteStageTypeId'];
            this.internalSalesAgentId = _data['internalSalesAgentId'];
            this.salesCampaignId = _data['salesCampaignId'];
            this.quoteStageType = _data['quoteStageType'] ? QuoteStageType.fromJS(_data['quoteStageType']) : <any>undefined;
            this.createAttribJson = _data['createAttribJson'];
            if (Array.isArray(_data['quoteManageEstMrc'])) {
                this.quoteManageEstMrc = [] as any;
                for (let item of _data['quoteManageEstMrc']) this.quoteManageEstMrc.push(QuoteManageEstMrcListDto.fromJS(item));
            }
            if (Array.isArray(_data['quoteUsers'])) {
                this.quoteUsers = [] as any;
                for (let item of _data['quoteUsers']) this.quoteUsers.push(QuoteUserEditDto.fromJS(item));
            }
            if (Array.isArray(_data['quoteLocations'])) {
                this.quoteLocations = [] as any;
                for (let item of _data['quoteLocations']) this.quoteLocations.push(QuoteLocationEditDto.fromJS(item));
            }
            if (Array.isArray(_data['quoteContractTerms'])) {
                this.quoteContractTerms = [] as any;
                for (let item of _data['quoteContractTerms']) this.quoteContractTerms.push(QuoteContractTermEditDto.fromJS(item));
            }
            if (Array.isArray(_data['quoteProviders'])) {
                this.quoteProviders = [] as any;
                for (let item of _data['quoteProviders']) this.quoteProviders.push(QuoteProviderEditDto.fromJS(item));
            }
            if (Array.isArray(_data['quoteProducts'])) {
                this.quoteProducts = [] as any;
                for (let item of _data['quoteProducts']) this.quoteProducts.push(QuoteProductEditDto.fromJS(item));
            }
            if (Array.isArray(_data['providerList'])) {
                this.providerList = [] as any;
                for (let item of _data['providerList']) this.providerList.push(ProviderListForQuote.fromJS(item));
            }
            this.ticketId = _data['ticketId'];
            this.ticketNumber = _data['ticketNumber'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): QuoteManageDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteManageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['quoteNumber'] = this.quoteNumber;
        data['orderId'] = this.orderId;
        data['partnerId'] = this.partnerId;
        data['partner'] = this.partner ? this.partner.toJSON() : <any>undefined;
        data['salesAgentId'] = this.salesAgentId;
        data['salesAgent'] = this.salesAgent ? this.salesAgent.toJSON() : <any>undefined;
        data['salesEngineerId'] = this.salesEngineerId;
        data['salesEngineer'] = this.salesEngineer ? this.salesEngineer.toJSON() : <any>undefined;
        data['customerId'] = this.customerId;
        data['customer'] = this.customer ? this.customer.toJSON() : <any>undefined;
        data['name'] = this.name;
        data['description'] = this.description;
        data['quoteStageTypeId'] = this.quoteStageTypeId;
        data['internalSalesAgentId'] = this.internalSalesAgentId;
        data['salesCampaignId'] = this.salesCampaignId;
        data['quoteStageType'] = this.quoteStageType ? this.quoteStageType.toJSON() : <any>undefined;
        data['createAttribJson'] = this.createAttribJson;
        if (Array.isArray(this.quoteManageEstMrc)) {
            data['quoteManageEstMrc'] = [];
            for (let item of this.quoteManageEstMrc) data['quoteManageEstMrc'].push(item.toJSON());
        }
        if (Array.isArray(this.quoteUsers)) {
            data['quoteUsers'] = [];
            for (let item of this.quoteUsers) data['quoteUsers'].push(item.toJSON());
        }
        if (Array.isArray(this.quoteLocations)) {
            data['quoteLocations'] = [];
            for (let item of this.quoteLocations) data['quoteLocations'].push(item.toJSON());
        }
        if (Array.isArray(this.quoteContractTerms)) {
            data['quoteContractTerms'] = [];
            for (let item of this.quoteContractTerms) data['quoteContractTerms'].push(item.toJSON());
        }
        if (Array.isArray(this.quoteProviders)) {
            data['quoteProviders'] = [];
            for (let item of this.quoteProviders) data['quoteProviders'].push(item.toJSON());
        }
        if (Array.isArray(this.quoteProducts)) {
            data['quoteProducts'] = [];
            for (let item of this.quoteProducts) data['quoteProducts'].push(item.toJSON());
        }
        if (Array.isArray(this.providerList)) {
            data['providerList'] = [];
            for (let item of this.providerList) data['providerList'].push(item.toJSON());
        }
        data['ticketId'] = this.ticketId;
        data['ticketNumber'] = this.ticketNumber;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): QuoteManageDto {
        const json = this.toJSON();
        let result = new QuoteManageDto();
        result.init(json);
        return result;
    }
}

export interface IQuoteManageDto {
    quoteNumber: string | undefined;
    orderId: number | undefined;
    partnerId: number;
    partner: PartnerEditDto;
    salesAgentId: number;
    salesAgent: UserListDto;
    salesEngineerId: number | undefined;
    salesEngineer: UserListDto;
    customerId: number;
    customer: CustomerEditDto;
    name: string | undefined;
    description: string | undefined;
    quoteStageTypeId: number;
    internalSalesAgentId: number | undefined;
    salesCampaignId: number | undefined;
    quoteStageType: QuoteStageType;
    createAttribJson: string | undefined;
    quoteManageEstMrc: QuoteManageEstMrcListDto[] | undefined;
    quoteUsers: QuoteUserEditDto[] | undefined;
    quoteLocations: QuoteLocationEditDto[] | undefined;
    quoteContractTerms: QuoteContractTermEditDto[] | undefined;
    quoteProviders: QuoteProviderEditDto[] | undefined;
    quoteProducts: QuoteProductEditDto[] | undefined;
    providerList: ProviderListForQuote[] | undefined;
    ticketId: number;
    ticketNumber: string | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class QuoteManageEstMrcDetailListDto implements IQuoteManageEstMrcDetailListDto {
    providerId: number;
    provider: string | undefined;
    estMrc: number;

    constructor(data?: IQuoteManageEstMrcDetailListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerId = _data['providerId'];
            this.provider = _data['provider'];
            this.estMrc = _data['estMrc'];
        }
    }

    static fromJS(data: any): QuoteManageEstMrcDetailListDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteManageEstMrcDetailListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['providerId'] = this.providerId;
        data['provider'] = this.provider;
        data['estMrc'] = this.estMrc;
        return data;
    }

    clone(): QuoteManageEstMrcDetailListDto {
        const json = this.toJSON();
        let result = new QuoteManageEstMrcDetailListDto();
        result.init(json);
        return result;
    }
}

export interface IQuoteManageEstMrcDetailListDto {
    providerId: number;
    provider: string | undefined;
    estMrc: number;
}

export class QuoteManageEstMrcListDto implements IQuoteManageEstMrcListDto {
    term: string | undefined;
    detail: QuoteManageEstMrcDetailListDto[] | undefined;

    constructor(data?: IQuoteManageEstMrcListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.term = _data['term'];
            if (Array.isArray(_data['detail'])) {
                this.detail = [] as any;
                for (let item of _data['detail']) this.detail.push(QuoteManageEstMrcDetailListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuoteManageEstMrcListDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteManageEstMrcListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['term'] = this.term;
        if (Array.isArray(this.detail)) {
            data['detail'] = [];
            for (let item of this.detail) data['detail'].push(item.toJSON());
        }
        return data;
    }

    clone(): QuoteManageEstMrcListDto {
        const json = this.toJSON();
        let result = new QuoteManageEstMrcListDto();
        result.init(json);
        return result;
    }
}

export interface IQuoteManageEstMrcListDto {
    term: string | undefined;
    detail: QuoteManageEstMrcDetailListDto[] | undefined;
}

export class QuotePriceDetail implements IQuotePriceDetail {
    tenantId: number | undefined;
    quoteId: number;
    quote: Quote;
    quoteProviderProductId: number;
    quoteProviderProduct: QuoteProviderProduct;
    quoteLocationId: number;
    quoteLocation: QuoteLocation;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    quotePriceDetailContracts: QuotePriceDetailContract[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IQuotePriceDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.quoteId = _data['quoteId'];
            this.quote = _data['quote'] ? Quote.fromJS(_data['quote']) : <any>undefined;
            this.quoteProviderProductId = _data['quoteProviderProductId'];
            this.quoteProviderProduct = _data['quoteProviderProduct']
                ? QuoteProviderProduct.fromJS(_data['quoteProviderProduct'])
                : <any>undefined;
            this.quoteLocationId = _data['quoteLocationId'];
            this.quoteLocation = _data['quoteLocation'] ? QuoteLocation.fromJS(_data['quoteLocation']) : <any>undefined;
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            if (Array.isArray(_data['quotePriceDetailContracts'])) {
                this.quotePriceDetailContracts = [] as any;
                for (let item of _data['quotePriceDetailContracts'])
                    this.quotePriceDetailContracts.push(QuotePriceDetailContract.fromJS(item));
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): QuotePriceDetail {
        data = typeof data === 'object' ? data : {};
        let result = new QuotePriceDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['quoteId'] = this.quoteId;
        data['quote'] = this.quote ? this.quote.toJSON() : <any>undefined;
        data['quoteProviderProductId'] = this.quoteProviderProductId;
        data['quoteProviderProduct'] = this.quoteProviderProduct ? this.quoteProviderProduct.toJSON() : <any>undefined;
        data['quoteLocationId'] = this.quoteLocationId;
        data['quoteLocation'] = this.quoteLocation ? this.quoteLocation.toJSON() : <any>undefined;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        if (Array.isArray(this.quotePriceDetailContracts)) {
            data['quotePriceDetailContracts'] = [];
            for (let item of this.quotePriceDetailContracts) data['quotePriceDetailContracts'].push(item.toJSON());
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): QuotePriceDetail {
        const json = this.toJSON();
        let result = new QuotePriceDetail();
        result.init(json);
        return result;
    }
}

export interface IQuotePriceDetail {
    tenantId: number | undefined;
    quoteId: number;
    quote: Quote;
    quoteProviderProductId: number;
    quoteProviderProduct: QuoteProviderProduct;
    quoteLocationId: number;
    quoteLocation: QuoteLocation;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    quotePriceDetailContracts: QuotePriceDetailContract[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class QuotePriceDetailContract implements IQuotePriceDetailContract {
    tenantId: number | undefined;
    quoteId: number;
    quote: Quote;
    quotePriceDetailId: number;
    quotePriceDetail: QuotePriceDetail;
    quoteContractTermId: number;
    quoteContractTerm: QuoteContractTerm;
    mrr: number | undefined;
    nrr: number | undefined;
    isSelected: boolean;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IQuotePriceDetailContract) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.quoteId = _data['quoteId'];
            this.quote = _data['quote'] ? Quote.fromJS(_data['quote']) : <any>undefined;
            this.quotePriceDetailId = _data['quotePriceDetailId'];
            this.quotePriceDetail = _data['quotePriceDetail'] ? QuotePriceDetail.fromJS(_data['quotePriceDetail']) : <any>undefined;
            this.quoteContractTermId = _data['quoteContractTermId'];
            this.quoteContractTerm = _data['quoteContractTerm'] ? QuoteContractTerm.fromJS(_data['quoteContractTerm']) : <any>undefined;
            this.mrr = _data['mrr'];
            this.nrr = _data['nrr'];
            this.isSelected = _data['isSelected'];
            this.isActive = _data['isActive'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): QuotePriceDetailContract {
        data = typeof data === 'object' ? data : {};
        let result = new QuotePriceDetailContract();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['quoteId'] = this.quoteId;
        data['quote'] = this.quote ? this.quote.toJSON() : <any>undefined;
        data['quotePriceDetailId'] = this.quotePriceDetailId;
        data['quotePriceDetail'] = this.quotePriceDetail ? this.quotePriceDetail.toJSON() : <any>undefined;
        data['quoteContractTermId'] = this.quoteContractTermId;
        data['quoteContractTerm'] = this.quoteContractTerm ? this.quoteContractTerm.toJSON() : <any>undefined;
        data['mrr'] = this.mrr;
        data['nrr'] = this.nrr;
        data['isSelected'] = this.isSelected;
        data['isActive'] = this.isActive;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): QuotePriceDetailContract {
        const json = this.toJSON();
        let result = new QuotePriceDetailContract();
        result.init(json);
        return result;
    }
}

export interface IQuotePriceDetailContract {
    tenantId: number | undefined;
    quoteId: number;
    quote: Quote;
    quotePriceDetailId: number;
    quotePriceDetail: QuotePriceDetail;
    quoteContractTermId: number;
    quoteContractTerm: QuoteContractTerm;
    mrr: number | undefined;
    nrr: number | undefined;
    isSelected: boolean;
    isActive: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class QuotePriceDetailContractDto implements IQuotePriceDetailContractDto {
    quotePriceDetailId: number;
    quoteContractTermId: number;
    quoteContractTerm: QuoteContractTermEditDto;
    mrr: number | undefined;
    nrr: number | undefined;
    isSelected: boolean;
    isActive: boolean;
    id: number;

    constructor(data?: IQuotePriceDetailContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quotePriceDetailId = _data['quotePriceDetailId'];
            this.quoteContractTermId = _data['quoteContractTermId'];
            this.quoteContractTerm = _data['quoteContractTerm']
                ? QuoteContractTermEditDto.fromJS(_data['quoteContractTerm'])
                : <any>undefined;
            this.mrr = _data['mrr'];
            this.nrr = _data['nrr'];
            this.isSelected = _data['isSelected'];
            this.isActive = _data['isActive'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): QuotePriceDetailContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotePriceDetailContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['quotePriceDetailId'] = this.quotePriceDetailId;
        data['quoteContractTermId'] = this.quoteContractTermId;
        data['quoteContractTerm'] = this.quoteContractTerm ? this.quoteContractTerm.toJSON() : <any>undefined;
        data['mrr'] = this.mrr;
        data['nrr'] = this.nrr;
        data['isSelected'] = this.isSelected;
        data['isActive'] = this.isActive;
        data['id'] = this.id;
        return data;
    }

    clone(): QuotePriceDetailContractDto {
        const json = this.toJSON();
        let result = new QuotePriceDetailContractDto();
        result.init(json);
        return result;
    }
}

export interface IQuotePriceDetailContractDto {
    quotePriceDetailId: number;
    quoteContractTermId: number;
    quoteContractTerm: QuoteContractTermEditDto;
    mrr: number | undefined;
    nrr: number | undefined;
    isSelected: boolean;
    isActive: boolean;
    id: number;
}

export class QuotePriceDetailContractEditDto implements IQuotePriceDetailContractEditDto {
    quotePriceDetailId: number;
    quotePriceDetail: QuotePriceDetail;
    quoteContractTermId: number;
    quoteContractTerm: QuoteContractTermEditDto;
    mrr: number | undefined;
    nrr: number | undefined;
    isSelected: boolean;
    isInactive: boolean;
    id: number;

    constructor(data?: IQuotePriceDetailContractEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quotePriceDetailId = _data['quotePriceDetailId'];
            this.quotePriceDetail = _data['quotePriceDetail'] ? QuotePriceDetail.fromJS(_data['quotePriceDetail']) : <any>undefined;
            this.quoteContractTermId = _data['quoteContractTermId'];
            this.quoteContractTerm = _data['quoteContractTerm']
                ? QuoteContractTermEditDto.fromJS(_data['quoteContractTerm'])
                : <any>undefined;
            this.mrr = _data['mrr'];
            this.nrr = _data['nrr'];
            this.isSelected = _data['isSelected'];
            this.isInactive = _data['isInactive'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): QuotePriceDetailContractEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotePriceDetailContractEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['quotePriceDetailId'] = this.quotePriceDetailId;
        data['quotePriceDetail'] = this.quotePriceDetail ? this.quotePriceDetail.toJSON() : <any>undefined;
        data['quoteContractTermId'] = this.quoteContractTermId;
        data['quoteContractTerm'] = this.quoteContractTerm ? this.quoteContractTerm.toJSON() : <any>undefined;
        data['mrr'] = this.mrr;
        data['nrr'] = this.nrr;
        data['isSelected'] = this.isSelected;
        data['isInactive'] = this.isInactive;
        data['id'] = this.id;
        return data;
    }

    clone(): QuotePriceDetailContractEditDto {
        const json = this.toJSON();
        let result = new QuotePriceDetailContractEditDto();
        result.init(json);
        return result;
    }
}

export interface IQuotePriceDetailContractEditDto {
    quotePriceDetailId: number;
    quotePriceDetail: QuotePriceDetail;
    quoteContractTermId: number;
    quoteContractTerm: QuoteContractTermEditDto;
    mrr: number | undefined;
    nrr: number | undefined;
    isSelected: boolean;
    isInactive: boolean;
    id: number;
}

export class QuotePriceDetailEditDto implements IQuotePriceDetailEditDto {
    quoteProviderProductId: number;
    quoteProviderProductEditDto: QuoteProviderProductEditDto;
    quoteLocationId: number;
    quoteLocation: QuoteLocationEditDto;
    quotePriceDetailContracts: QuotePriceDetailContractEditDto[] | undefined;
    id: number;

    constructor(data?: IQuotePriceDetailEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteProviderProductId = _data['quoteProviderProductId'];
            this.quoteProviderProductEditDto = _data['quoteProviderProductEditDto']
                ? QuoteProviderProductEditDto.fromJS(_data['quoteProviderProductEditDto'])
                : <any>undefined;
            this.quoteLocationId = _data['quoteLocationId'];
            this.quoteLocation = _data['quoteLocation'] ? QuoteLocationEditDto.fromJS(_data['quoteLocation']) : <any>undefined;
            if (Array.isArray(_data['quotePriceDetailContracts'])) {
                this.quotePriceDetailContracts = [] as any;
                for (let item of _data['quotePriceDetailContracts'])
                    this.quotePriceDetailContracts.push(QuotePriceDetailContractEditDto.fromJS(item));
            }
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): QuotePriceDetailEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuotePriceDetailEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['quoteProviderProductId'] = this.quoteProviderProductId;
        data['quoteProviderProductEditDto'] = this.quoteProviderProductEditDto ? this.quoteProviderProductEditDto.toJSON() : <any>undefined;
        data['quoteLocationId'] = this.quoteLocationId;
        data['quoteLocation'] = this.quoteLocation ? this.quoteLocation.toJSON() : <any>undefined;
        if (Array.isArray(this.quotePriceDetailContracts)) {
            data['quotePriceDetailContracts'] = [];
            for (let item of this.quotePriceDetailContracts) data['quotePriceDetailContracts'].push(item.toJSON());
        }
        data['id'] = this.id;
        return data;
    }

    clone(): QuotePriceDetailEditDto {
        const json = this.toJSON();
        let result = new QuotePriceDetailEditDto();
        result.init(json);
        return result;
    }
}

export interface IQuotePriceDetailEditDto {
    quoteProviderProductId: number;
    quoteProviderProductEditDto: QuoteProviderProductEditDto;
    quoteLocationId: number;
    quoteLocation: QuoteLocationEditDto;
    quotePriceDetailContracts: QuotePriceDetailContractEditDto[] | undefined;
    id: number;
}

export class QuoteProduct implements IQuoteProduct {
    tenantId: number | undefined;
    quoteId: number;
    quote: Quote;
    productId: number;
    product: Product;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    quoteProviderProducts: QuoteProviderProduct[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IQuoteProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.quoteId = _data['quoteId'];
            this.quote = _data['quote'] ? Quote.fromJS(_data['quote']) : <any>undefined;
            this.productId = _data['productId'];
            this.product = _data['product'] ? Product.fromJS(_data['product']) : <any>undefined;
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            if (Array.isArray(_data['quoteProviderProducts'])) {
                this.quoteProviderProducts = [] as any;
                for (let item of _data['quoteProviderProducts']) this.quoteProviderProducts.push(QuoteProviderProduct.fromJS(item));
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): QuoteProduct {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['quoteId'] = this.quoteId;
        data['quote'] = this.quote ? this.quote.toJSON() : <any>undefined;
        data['productId'] = this.productId;
        data['product'] = this.product ? this.product.toJSON() : <any>undefined;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        if (Array.isArray(this.quoteProviderProducts)) {
            data['quoteProviderProducts'] = [];
            for (let item of this.quoteProviderProducts) data['quoteProviderProducts'].push(item.toJSON());
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): QuoteProduct {
        const json = this.toJSON();
        let result = new QuoteProduct();
        result.init(json);
        return result;
    }
}

export interface IQuoteProduct {
    tenantId: number | undefined;
    quoteId: number;
    quote: Quote;
    productId: number;
    product: Product;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    quoteProviderProducts: QuoteProviderProduct[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class QuoteProductEditDto implements IQuoteProductEditDto {
    quoteId: number;
    productId: number;
    product: ProductListDto;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IQuoteProductEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteId = _data['quoteId'];
            this.productId = _data['productId'];
            this.product = _data['product'] ? ProductListDto.fromJS(_data['product']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): QuoteProductEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteProductEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['quoteId'] = this.quoteId;
        data['productId'] = this.productId;
        data['product'] = this.product ? this.product.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): QuoteProductEditDto {
        const json = this.toJSON();
        let result = new QuoteProductEditDto();
        result.init(json);
        return result;
    }
}

export interface IQuoteProductEditDto {
    quoteId: number;
    productId: number;
    product: ProductListDto;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class QuoteProvider implements IQuoteProvider {
    tenantId: number | undefined;
    quoteId: number;
    quote: Quote;
    providerId: number;
    provider: Provider;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    quoteProviderProducts: QuoteProviderProduct[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IQuoteProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.quoteId = _data['quoteId'];
            this.quote = _data['quote'] ? Quote.fromJS(_data['quote']) : <any>undefined;
            this.providerId = _data['providerId'];
            this.provider = _data['provider'] ? Provider.fromJS(_data['provider']) : <any>undefined;
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            if (Array.isArray(_data['quoteProviderProducts'])) {
                this.quoteProviderProducts = [] as any;
                for (let item of _data['quoteProviderProducts']) this.quoteProviderProducts.push(QuoteProviderProduct.fromJS(item));
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): QuoteProvider {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['quoteId'] = this.quoteId;
        data['quote'] = this.quote ? this.quote.toJSON() : <any>undefined;
        data['providerId'] = this.providerId;
        data['provider'] = this.provider ? this.provider.toJSON() : <any>undefined;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        if (Array.isArray(this.quoteProviderProducts)) {
            data['quoteProviderProducts'] = [];
            for (let item of this.quoteProviderProducts) data['quoteProviderProducts'].push(item.toJSON());
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): QuoteProvider {
        const json = this.toJSON();
        let result = new QuoteProvider();
        result.init(json);
        return result;
    }
}

export interface IQuoteProvider {
    tenantId: number | undefined;
    quoteId: number;
    quote: Quote;
    providerId: number;
    provider: Provider;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    quoteProviderProducts: QuoteProviderProduct[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class QuoteProviderEditDto implements IQuoteProviderEditDto {
    quoteId: number;
    providerId: number;
    provider: ProviderListDto;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IQuoteProviderEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteId = _data['quoteId'];
            this.providerId = _data['providerId'];
            this.provider = _data['provider'] ? ProviderListDto.fromJS(_data['provider']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): QuoteProviderEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteProviderEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['quoteId'] = this.quoteId;
        data['providerId'] = this.providerId;
        data['provider'] = this.provider ? this.provider.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): QuoteProviderEditDto {
        const json = this.toJSON();
        let result = new QuoteProviderEditDto();
        result.init(json);
        return result;
    }
}

export interface IQuoteProviderEditDto {
    quoteId: number;
    providerId: number;
    provider: ProviderListDto;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class QuoteProviderProduct implements IQuoteProviderProduct {
    tenantId: number | undefined;
    quoteId: number;
    quote: Quote;
    quoteProviderId: number;
    quoteProvider: QuoteProvider;
    quoteProductId: number;
    quoteProduct: QuoteProduct;
    quoteStatusId: number;
    quoteStatus: QuoteStatus;
    dateOfRequest: moment.Moment | undefined;
    datePriceComplete: moment.Moment | undefined;
    dateSentToProvider: moment.Moment | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    quotePriceDetails: QuotePriceDetail[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IQuoteProviderProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.quoteId = _data['quoteId'];
            this.quote = _data['quote'] ? Quote.fromJS(_data['quote']) : <any>undefined;
            this.quoteProviderId = _data['quoteProviderId'];
            this.quoteProvider = _data['quoteProvider'] ? QuoteProvider.fromJS(_data['quoteProvider']) : <any>undefined;
            this.quoteProductId = _data['quoteProductId'];
            this.quoteProduct = _data['quoteProduct'] ? QuoteProduct.fromJS(_data['quoteProduct']) : <any>undefined;
            this.quoteStatusId = _data['quoteStatusId'];
            this.quoteStatus = _data['quoteStatus'] ? QuoteStatus.fromJS(_data['quoteStatus']) : <any>undefined;
            this.dateOfRequest = _data['dateOfRequest'] ? moment(_data['dateOfRequest'].toString()) : <any>undefined;
            this.datePriceComplete = _data['datePriceComplete'] ? moment(_data['datePriceComplete'].toString()) : <any>undefined;
            this.dateSentToProvider = _data['dateSentToProvider'] ? moment(_data['dateSentToProvider'].toString()) : <any>undefined;
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            if (Array.isArray(_data['quotePriceDetails'])) {
                this.quotePriceDetails = [] as any;
                for (let item of _data['quotePriceDetails']) this.quotePriceDetails.push(QuotePriceDetail.fromJS(item));
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): QuoteProviderProduct {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteProviderProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['quoteId'] = this.quoteId;
        data['quote'] = this.quote ? this.quote.toJSON() : <any>undefined;
        data['quoteProviderId'] = this.quoteProviderId;
        data['quoteProvider'] = this.quoteProvider ? this.quoteProvider.toJSON() : <any>undefined;
        data['quoteProductId'] = this.quoteProductId;
        data['quoteProduct'] = this.quoteProduct ? this.quoteProduct.toJSON() : <any>undefined;
        data['quoteStatusId'] = this.quoteStatusId;
        data['quoteStatus'] = this.quoteStatus ? this.quoteStatus.toJSON() : <any>undefined;
        data['dateOfRequest'] = this.dateOfRequest ? this.dateOfRequest.toISOString() : <any>undefined;
        data['datePriceComplete'] = this.datePriceComplete ? this.datePriceComplete.toISOString() : <any>undefined;
        data['dateSentToProvider'] = this.dateSentToProvider ? this.dateSentToProvider.toISOString() : <any>undefined;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        if (Array.isArray(this.quotePriceDetails)) {
            data['quotePriceDetails'] = [];
            for (let item of this.quotePriceDetails) data['quotePriceDetails'].push(item.toJSON());
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): QuoteProviderProduct {
        const json = this.toJSON();
        let result = new QuoteProviderProduct();
        result.init(json);
        return result;
    }
}

export interface IQuoteProviderProduct {
    tenantId: number | undefined;
    quoteId: number;
    quote: Quote;
    quoteProviderId: number;
    quoteProvider: QuoteProvider;
    quoteProductId: number;
    quoteProduct: QuoteProduct;
    quoteStatusId: number;
    quoteStatus: QuoteStatus;
    dateOfRequest: moment.Moment | undefined;
    datePriceComplete: moment.Moment | undefined;
    dateSentToProvider: moment.Moment | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    quotePriceDetails: QuotePriceDetail[] | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class QuoteProviderProductEditDto implements IQuoteProviderProductEditDto {
    quoteId: number;
    quoteProviderId: number;
    provider: ProviderEditDto;
    quoteProductId: number;
    product: ProductEditDto;
    quoteStatusId: number;
    quoteStatus: QuoteStatusDto;
    dateOfRequest: moment.Moment | undefined;
    datePriceComplete: moment.Moment | undefined;
    dateSentToProvider: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IQuoteProviderProductEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteId = _data['quoteId'];
            this.quoteProviderId = _data['quoteProviderId'];
            this.provider = _data['provider'] ? ProviderEditDto.fromJS(_data['provider']) : <any>undefined;
            this.quoteProductId = _data['quoteProductId'];
            this.product = _data['product'] ? ProductEditDto.fromJS(_data['product']) : <any>undefined;
            this.quoteStatusId = _data['quoteStatusId'];
            this.quoteStatus = _data['quoteStatus'] ? QuoteStatusDto.fromJS(_data['quoteStatus']) : <any>undefined;
            this.dateOfRequest = _data['dateOfRequest'] ? moment(_data['dateOfRequest'].toString()) : <any>undefined;
            this.datePriceComplete = _data['datePriceComplete'] ? moment(_data['datePriceComplete'].toString()) : <any>undefined;
            this.dateSentToProvider = _data['dateSentToProvider'] ? moment(_data['dateSentToProvider'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): QuoteProviderProductEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteProviderProductEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['quoteId'] = this.quoteId;
        data['quoteProviderId'] = this.quoteProviderId;
        data['provider'] = this.provider ? this.provider.toJSON() : <any>undefined;
        data['quoteProductId'] = this.quoteProductId;
        data['product'] = this.product ? this.product.toJSON() : <any>undefined;
        data['quoteStatusId'] = this.quoteStatusId;
        data['quoteStatus'] = this.quoteStatus ? this.quoteStatus.toJSON() : <any>undefined;
        data['dateOfRequest'] = this.dateOfRequest ? this.dateOfRequest.toISOString() : <any>undefined;
        data['datePriceComplete'] = this.datePriceComplete ? this.datePriceComplete.toISOString() : <any>undefined;
        data['dateSentToProvider'] = this.dateSentToProvider ? this.dateSentToProvider.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): QuoteProviderProductEditDto {
        const json = this.toJSON();
        let result = new QuoteProviderProductEditDto();
        result.init(json);
        return result;
    }
}

export interface IQuoteProviderProductEditDto {
    quoteId: number;
    quoteProviderId: number;
    provider: ProviderEditDto;
    quoteProductId: number;
    product: ProductEditDto;
    quoteStatusId: number;
    quoteStatus: QuoteStatusDto;
    dateOfRequest: moment.Moment | undefined;
    datePriceComplete: moment.Moment | undefined;
    dateSentToProvider: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class QuoteStageType implements IQuoteStageType {
    tenantId: number | undefined;
    name: string | undefined;
    order: number;
    inPricing: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IQuoteStageType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.order = _data['order'];
            this.inPricing = _data['inPricing'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): QuoteStageType {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteStageType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['order'] = this.order;
        data['inPricing'] = this.inPricing;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): QuoteStageType {
        const json = this.toJSON();
        let result = new QuoteStageType();
        result.init(json);
        return result;
    }
}

export interface IQuoteStageType {
    tenantId: number | undefined;
    name: string | undefined;
    order: number;
    inPricing: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class QuoteStageTypeDto implements IQuoteStageTypeDto {
    name: string | undefined;
    order: number;
    inPricing: boolean;
    id: number;

    constructor(data?: IQuoteStageTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.order = _data['order'];
            this.inPricing = _data['inPricing'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): QuoteStageTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteStageTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['order'] = this.order;
        data['inPricing'] = this.inPricing;
        data['id'] = this.id;
        return data;
    }

    clone(): QuoteStageTypeDto {
        const json = this.toJSON();
        let result = new QuoteStageTypeDto();
        result.init(json);
        return result;
    }
}

export interface IQuoteStageTypeDto {
    name: string | undefined;
    order: number;
    inPricing: boolean;
    id: number;
}

export class QuoteStatus implements IQuoteStatus {
    tenantId: number | undefined;
    name: string | undefined;
    statusType: QuoteStatusType;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IQuoteStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.statusType = _data['statusType'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): QuoteStatus {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['statusType'] = this.statusType;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): QuoteStatus {
        const json = this.toJSON();
        let result = new QuoteStatus();
        result.init(json);
        return result;
    }
}

export interface IQuoteStatus {
    tenantId: number | undefined;
    name: string | undefined;
    statusType: QuoteStatusType;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class QuoteStatusDto implements IQuoteStatusDto {
    tenantId: number | undefined;
    name: string | undefined;
    statusType: QuoteStatusType;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IQuoteStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.statusType = _data['statusType'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): QuoteStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['statusType'] = this.statusType;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): QuoteStatusDto {
        const json = this.toJSON();
        let result = new QuoteStatusDto();
        result.init(json);
        return result;
    }
}

export interface IQuoteStatusDto {
    tenantId: number | undefined;
    name: string | undefined;
    statusType: QuoteStatusType;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export enum QuoteStatusType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class QuoteTrendingReportOutput implements IQuoteTrendingReportOutput {
    searchType: string | undefined;
    quotes: number[] | undefined;
    headers: string[] | undefined;

    constructor(data?: IQuoteTrendingReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchType = _data['searchType'];
            if (Array.isArray(_data['quotes'])) {
                this.quotes = [] as any;
                for (let item of _data['quotes']) this.quotes.push(item);
            }
            if (Array.isArray(_data['headers'])) {
                this.headers = [] as any;
                for (let item of _data['headers']) this.headers.push(item);
            }
        }
    }

    static fromJS(data: any): QuoteTrendingReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteTrendingReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['searchType'] = this.searchType;
        if (Array.isArray(this.quotes)) {
            data['quotes'] = [];
            for (let item of this.quotes) data['quotes'].push(item);
        }
        if (Array.isArray(this.headers)) {
            data['headers'] = [];
            for (let item of this.headers) data['headers'].push(item);
        }
        return data;
    }

    clone(): QuoteTrendingReportOutput {
        const json = this.toJSON();
        let result = new QuoteTrendingReportOutput();
        result.init(json);
        return result;
    }
}

export interface IQuoteTrendingReportOutput {
    searchType: string | undefined;
    quotes: number[] | undefined;
    headers: string[] | undefined;
}

export class QuoteUser implements IQuoteUser {
    tenantId: number | undefined;
    quoteId: number;
    quote: Quote;
    userId: number;
    user: User;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IQuoteUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.quoteId = _data['quoteId'];
            this.quote = _data['quote'] ? Quote.fromJS(_data['quote']) : <any>undefined;
            this.userId = _data['userId'];
            this.user = _data['user'] ? User.fromJS(_data['user']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): QuoteUser {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['quoteId'] = this.quoteId;
        data['quote'] = this.quote ? this.quote.toJSON() : <any>undefined;
        data['userId'] = this.userId;
        data['user'] = this.user ? this.user.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): QuoteUser {
        const json = this.toJSON();
        let result = new QuoteUser();
        result.init(json);
        return result;
    }
}

export interface IQuoteUser {
    tenantId: number | undefined;
    quoteId: number;
    quote: Quote;
    userId: number;
    user: User;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class QuoteUserEditDto implements IQuoteUserEditDto {
    tenantId: number | undefined;
    quoteId: number;
    userId: number;
    user: UserListDto;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IQuoteUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.quoteId = _data['quoteId'];
            this.userId = _data['userId'];
            this.user = _data['user'] ? UserListDto.fromJS(_data['user']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): QuoteUserEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteUserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['quoteId'] = this.quoteId;
        data['userId'] = this.userId;
        data['user'] = this.user ? this.user.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): QuoteUserEditDto {
        const json = this.toJSON();
        let result = new QuoteUserEditDto();
        result.init(json);
        return result;
    }
}

export interface IQuoteUserEditDto {
    tenantId: number | undefined;
    quoteId: number;
    userId: number;
    user: UserListDto;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class QuoteUserListDto implements IQuoteUserListDto {
    tenantId: number | undefined;
    quoteId: number;
    user: UserListDto;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;

    constructor(data?: IQuoteUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.quoteId = _data['quoteId'];
            this.user = _data['user'] ? UserListDto.fromJS(_data['user']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): QuoteUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuoteUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['quoteId'] = this.quoteId;
        data['user'] = this.user ? this.user.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['id'] = this.id;
        return data;
    }

    clone(): QuoteUserListDto {
        const json = this.toJSON();
        let result = new QuoteUserListDto();
        result.init(json);
        return result;
    }
}

export interface IQuoteUserListDto {
    tenantId: number | undefined;
    quoteId: number;
    user: UserListDto;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    id: number;
}

export class QuotesCountByStageDashboardOutput implements IQuotesCountByStageDashboardOutput {
    stage: string | undefined;
    count: number;

    constructor(data?: IQuotesCountByStageDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stage = _data['stage'];
            this.count = _data['count'];
        }
    }

    static fromJS(data: any): QuotesCountByStageDashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new QuotesCountByStageDashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['stage'] = this.stage;
        data['count'] = this.count;
        return data;
    }

    clone(): QuotesCountByStageDashboardOutput {
        const json = this.toJSON();
        let result = new QuotesCountByStageDashboardOutput();
        result.init(json);
        return result;
    }
}

export interface IQuotesCountByStageDashboardOutput {
    stage: string | undefined;
    count: number;
}

export class QuotesDashboardOutput implements IQuotesDashboardOutput {
    quoteId: number;
    name: string | undefined;
    customer: string | undefined;
    salesAgent: string | undefined;
    stage: string | undefined;
    daysOld: number;
    received: moment.Moment;
    salesSupport: string | undefined;
    quoteNumber: string | undefined;

    constructor(data?: IQuotesDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteId = _data['quoteId'];
            this.name = _data['name'];
            this.customer = _data['customer'];
            this.salesAgent = _data['salesAgent'];
            this.stage = _data['stage'];
            this.daysOld = _data['daysOld'];
            this.received = _data['received'] ? moment(_data['received'].toString()) : <any>undefined;
            this.salesSupport = _data['salesSupport'];
            this.quoteNumber = _data['quoteNumber'];
        }
    }

    static fromJS(data: any): QuotesDashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new QuotesDashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['quoteId'] = this.quoteId;
        data['name'] = this.name;
        data['customer'] = this.customer;
        data['salesAgent'] = this.salesAgent;
        data['stage'] = this.stage;
        data['daysOld'] = this.daysOld;
        data['received'] = this.received ? this.received.toISOString() : <any>undefined;
        data['salesSupport'] = this.salesSupport;
        data['quoteNumber'] = this.quoteNumber;
        return data;
    }

    clone(): QuotesDashboardOutput {
        const json = this.toJSON();
        let result = new QuotesDashboardOutput();
        result.init(json);
        return result;
    }
}

export interface IQuotesDashboardOutput {
    quoteId: number;
    name: string | undefined;
    customer: string | undefined;
    salesAgent: string | undefined;
    stage: string | undefined;
    daysOld: number;
    received: moment.Moment;
    salesSupport: string | undefined;
    quoteNumber: string | undefined;
}

export class SalesSupportUsersDashboardOutput implements ISalesSupportUsersDashboardOutput {
    user: string | undefined;
    quoteCount: number;
    pastDue: number | undefined;
    dueToday: number | undefined;
    noFollowUp: number | undefined;
    withinFourHoursNotifications: number | undefined;
    afterFourHoursNotifications: number | undefined;
    ticketCount: number | undefined;

    constructor(data?: ISalesSupportUsersDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data['user'];
            this.quoteCount = _data['quoteCount'];
            this.pastDue = _data['pastDue'];
            this.dueToday = _data['dueToday'];
            this.noFollowUp = _data['noFollowUp'];
            this.withinFourHoursNotifications = _data['withinFourHoursNotifications'];
            this.afterFourHoursNotifications = _data['afterFourHoursNotifications'];
            this.ticketCount = _data['ticketCount'];
        }
    }

    static fromJS(data: any): SalesSupportUsersDashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SalesSupportUsersDashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['user'] = this.user;
        data['quoteCount'] = this.quoteCount;
        data['pastDue'] = this.pastDue;
        data['dueToday'] = this.dueToday;
        data['noFollowUp'] = this.noFollowUp;
        data['withinFourHoursNotifications'] = this.withinFourHoursNotifications;
        data['afterFourHoursNotifications'] = this.afterFourHoursNotifications;
        data['ticketCount'] = this.ticketCount;
        return data;
    }

    clone(): SalesSupportUsersDashboardOutput {
        const json = this.toJSON();
        let result = new SalesSupportUsersDashboardOutput();
        result.init(json);
        return result;
    }
}

export interface ISalesSupportUsersDashboardOutput {
    user: string | undefined;
    quoteCount: number;
    pastDue: number | undefined;
    dueToday: number | undefined;
    noFollowUp: number | undefined;
    withinFourHoursNotifications: number | undefined;
    afterFourHoursNotifications: number | undefined;
    ticketCount: number | undefined;
}

export class UpdateQuoteReviewInput implements IUpdateQuoteReviewInput {
    id: number;
    name: string | undefined;
    description: string | undefined;

    constructor(data?: IUpdateQuoteReviewInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.description = _data['description'];
        }
    }

    static fromJS(data: any): UpdateQuoteReviewInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuoteReviewInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['description'] = this.description;
        return data;
    }

    clone(): UpdateQuoteReviewInput {
        const json = this.toJSON();
        let result = new UpdateQuoteReviewInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateQuoteReviewInput {
    id: number;
    name: string | undefined;
    description: string | undefined;
}

export class UpdateQuoteStageInput implements IUpdateQuoteStageInput {
    quoteId: number;
    quoteStageTypeId: number;

    constructor(data?: IUpdateQuoteStageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.quoteId = _data['quoteId'];
            this.quoteStageTypeId = _data['quoteStageTypeId'];
        }
    }

    static fromJS(data: any): UpdateQuoteStageInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuoteStageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['quoteId'] = this.quoteId;
        data['quoteStageTypeId'] = this.quoteStageTypeId;
        return data;
    }

    clone(): UpdateQuoteStageInput {
        const json = this.toJSON();
        let result = new UpdateQuoteStageInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateQuoteStageInput {
    quoteId: number;
    quoteStageTypeId: number;
}
